import React, { useEffect, useMemo, useState } from "react";
import ResimUpload from "../ResimUpload";

const API_BASE = "https://panel.haymestasarim.com/api";

function tokenHeader() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/")) return `https://panel.haymestasarim.com${url}`;
  return `https://panel.haymestasarim.com/${url}`;
}

function dateOnly(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

function formatDate(value) {
  if (!value) return "-";

  const d = new Date(value);

  if (Number.isNaN(d.getTime())) {
    return String(value).slice(0, 10);
  }

  return d.toLocaleDateString("tr-TR");
}

const TEXT = {
  tr: {
    loading: "Yükleniyor...",
    title: "💇‍♀️ Kuaför & Güzellik Salonu Yönetimi",
    subtitle: "Hizmet kataloğu, fiyat listesi, SSS ve randevu taleplerini buradan yönetin.",
    category: "Kategori",
    service: "Hizmet",
    faqs: "SSS",
    newAppointment: "Yeni Randevu",
    services: "Hizmetler",
    categories: "Kategoriler",
    appointments: "Randevular",
    editCategory: "Kategori Düzenle",
    newCategory: "Yeni Kategori Ekle",
    editService: "Hizmet Düzenle",
    newService: "Yeni Hizmet Ekle",
    editFaq: "SSS Düzenle",
    newFaq: "Yeni SSS Ekle",
    appointmentRequests: "Randevu Talepleri",
    noAppointment: "Henüz randevu talebi yok.",
    selectCategory: "Kategori seç",
    titleField: "Başlık",
    descField: "Açıklama",
    questionField: "Soru",
    answerField: "Cevap",
    price: "Fiyat",
    currency: "Para Birimi",
    duration: "Süre / Dakika",
    image: "Görsel",
gender: "Cinsiyet",
male: "Erkek",
female: "Kadın",
    uploadImage: "📤 Görsel Yükle",
    preview: "Önizleme",
    featured: "Öne çıkan hizmet",
    featuredBadge: "Öne Çıkan",
    active: "Aktif",
    save: "Kaydet",
    update: "Güncelle",
    edit: "Düzenle",
    delete: "Sil",
    seen: "Görüldü",
    completed: "Tamamlandı",
    status: "Durum",
    pleaseSelectCategory: "Lütfen kategori seç.",
    confirmDelete: "Silmek istediğine emin misin?",
    emptyLang: "boş",
googleReviewSettings: "⭐ Google Yorum Ayarı",
googleReviewUrl: "Google Yorum Linki",
googleReviewTitle: "Yorum Başlığı",
googleReviewDesc: "Yorum Açıklaması",
googleReviewActive: "Google yorum butonunu göster",
googleReviewSave: "Google Yorum Ayarını Kaydet",
googleReviewSaved: "Google yorum ayarı kaydedildi.",
    customers: "Müşteriler",
    devices: "Cihazlar",
    packages: "Paketler",
    sessions: "Seanslar",
    staff: "Personel",
    payments: "Tahsilat",
    reports: "Raporlar",
    proTitle: "Beauty PRO Yönetim Modülü",
    proSubtitle: "Müşteri, cihaz, paket, seans, personel ve tahsilat takibini  buradan yönetin.",
    customerName: "Müşteri Adı",
    phone: "Telefon",
    gender: "Cinsiyet",
    female: "Kadın",
    male: "Erkek",
    note: "Not",
    deviceName: "Cihaz Adı",
    areaName: "Bölge / Hizmet",
    femalePrice: "Kadın Fiyatı",
    malePrice: "Erkek Fiyatı",
    packageName: "Paket Adı",
    totalSessions: "Toplam Seans",
    usedSessions: "Kullanılan",
    remainingSessions: "Kalan",
    assignedCustomer: "Müşteri",
    assignedPackage: "Paket",
    staffName: "Personel Adı",
    expertise: "Uzmanlık",
    amount: "Tutar",
    paid: "Ödenen",
    remainingDebt: "Kalan Borç",
    dueDate: "Vade Tarihi",
    addCustomer: "Müşteri Ekle",
    addDevice: "Cihaz Ekle",
    addPackage: "Paket Ekle",
    addSession: "Seans İşle",
    addStaff: "Personel Ekle",
    addPayment: "Tahsilat Ekle",
    sessionCompleted: "Seans tamamlandı",
    noRecord: "Henüz kayıt yok.",
    localNotice: "Bu bölüm veritabanına bağlıdır. Kayıtlar Beauty PRO tablolarına kaydedilir.",

  },
  en: {
    loading: "Loading...",
    title: "💇‍♀️ Hairdresser & Beauty Salon Management",
    subtitle: "Manage service catalog, price list, FAQ and appointment requests here.",
    category: "Category",
    service: "Service",
    faqs: "FAQ",
    newAppointment: "New Appointment",
    services: "Services",
    categories: "Categories",
    appointments: "Appointments",
    editCategory: "Edit Category",
    newCategory: "Add New Category",
    editService: "Edit Service",
    newService: "Add New Service",
    editFaq: "Edit FAQ",
    newFaq: "Add New FAQ",
    appointmentRequests: "Appointment Requests",
    noAppointment: "No appointment requests yet.",
    selectCategory: "Select category",
    titleField: "Title",
    descField: "Description",
    questionField: "Question",
    answerField: "Answer",
    price: "Price",
    currency: "Currency",
    duration: "Duration / Minutes",
    image: "Image",
    uploadImage: "📤 Upload Image",
    preview: "Preview",
    featured: "Featured service",
    featuredBadge: "Featured",
    active: "Active",
    save: "Save",
    update: "Update",
    edit: "Edit",
    delete: "Delete",
gender: "Cinsiyet",
male: "Erkek",
female: "Kadın",
    seen: "Seen",
    completed: "Completed",
    status: "Status",
    pleaseSelectCategory: "Please select a category.",
    confirmDelete: "Are you sure you want to delete?",
    emptyLang: "empty",
googleReviewSettings: "⭐ Google Review Settings",
googleReviewUrl: "Google Review Link",
googleReviewTitle: "Review Title",
googleReviewDesc: "Review Description",
googleReviewActive: "Show Google review button",
googleReviewSave: "Save Google Review Settings",
googleReviewSaved: "Google review setting saved.",
    customers: "Customers",
    devices: "Devices",
    packages: "Packages",
    sessions: "Sessions",
    staff: "Staff",
    payments: "Payments",
    reports: "Reports",
    proTitle: "Beauty PRO Management Module",
    proSubtitle: "Manage customers, devices, packages, sessions, breaking the existing structure.",
    customerName: "Customer Name",
    phone: "Phone",
    gender: "Gender",
    female: "Female",
    male: "Male",
    note: "Note",
    deviceName: "Device Name",
    areaName: "Area / Service",
    femalePrice: "Female Price",
    malePrice: "Male Price",
    packageName: "Package Name",
    totalSessions: "Total Sessions",
    usedSessions: "Used",
    remainingSessions: "Remaining",
    assignedCustomer: "Customer",
    assignedPackage: "Package",
    staffName: "Staff Name",
    expertise: "Expertise",
    amount: "Amount",
    paid: "Paid",
    remainingDebt: "Remaining Debt",
    dueDate: "Due Date",
    addCustomer: "Add Customer",
    addDevice: "Add Device",
    addPackage: "Add Package",
    addSession: "Add Session",
    addStaff: "Add Staff",
    addPayment: "Add Payment",
    sessionCompleted: "Session completed",
    noRecord: "No records yet.",
    localNotice: "This section is connected to the database. Records are saved to Beauty PRO tables.",
  },
  de: {
    loading: "Wird geladen...",
    title: "💇‍♀️ Friseur- & Schönheitssalon-Verwaltung",
    subtitle: "Verwalten Sie hier Dienstleistungskatalog, Preisliste, FAQ und Terminanfragen.",
    category: "Kategorie",
    service: "Dienstleistung",
    faqs: "FAQ",
    newAppointment: "Neue Terminanfrage",
    services: "Dienstleistungen",
    categories: "Kategorien",
    appointments: "Termine",
    editCategory: "Kategorie bearbeiten",
    newCategory: "Neue Kategorie hinzufügen",
    editService: "Dienstleistung bearbeiten",
    newService: "Neue Dienstleistung hinzufügen",
    editFaq: "FAQ bearbeiten",
    newFaq: "FAQ hinzufügen",
    appointmentRequests: "Terminanfragen",
    noAppointment: "Noch keine Terminanfrage vorhanden.",
    selectCategory: "Kategorie auswählen",
    titleField: "Titel",
    descField: "Beschreibung",
    questionField: "Frage",
    answerField: "Antwort",
    price: "Preis",
    currency: "Währung",
    duration: "Dauer / Minuten",
    image: "Bild",
    uploadImage: "📤 Bild hochladen",
    preview: "Vorschau",
    featured: "Empfohlene Dienstleistung",
    featuredBadge: "Empfohlen",
    active: "Aktiv",
    save: "Speichern",
    update: "Aktualisieren",
    edit: "Bearbeiten",
    delete: "Löschen",
    seen: "Gesehen",
    completed: "Abgeschlossen",
    status: "Status",
    pleaseSelectCategory: "Bitte wählen Sie eine Kategorie.",
    confirmDelete: "Möchten Sie wirklich löschen?",
    emptyLang: "leer",
googleReviewSettings: "⭐ Google-Bewertung Einstellungen",
googleReviewUrl: "Google Bewertungslink",
googleReviewTitle: "Bewertungstitel",
googleReviewDesc: "Bewertungsbeschreibung",
googleReviewActive: "Google-Bewertungsbutton anzeigen",
googleReviewSave: "Google-Bewertung speichern",
googleReviewSaved: "Google-Bewertung wurde gespeichert.",
    customers: "Kunden",
    devices: "Geräte",
    packages: "Pakete",
    sessions: "Sitzungen",
    staff: "Personal",
    payments: "Zahlungen",
    reports: "Berichte",
    proTitle: "Beauty PRO Verwaltungsmodul",
    proSubtitle: "Kunden, Geräte, Pakete, Sitzungen, Personal und Zahlungen verwalten,  zu ändern.",
    customerName: "Kundenname",
    phone: "Telefon",
    gender: "Geschlecht",
    female: "Frau",
    male: "Mann",
    note: "Notiz",
    deviceName: "Gerätename",
    areaName: "Bereich / Dienstleistung",
    femalePrice: "Preis Frauen",
    malePrice: "Preis Männer",
    packageName: "Paketname",
    totalSessions: "Gesamtsitzungen",
    usedSessions: "Genutzt",
    remainingSessions: "Verbleibend",
    assignedCustomer: "Kunde",
    assignedPackage: "Paket",
    staffName: "Personalname",
    expertise: "Fachgebiet",
    amount: "Betrag",
    paid: "Bezahlt",
gender: "Gender",
male: "Male",
female: "Female",
    remainingDebt: "Restschuld",
    dueDate: "Fälligkeitsdatum",
    addCustomer: "Kunde hinzufügen",
    addDevice: "Gerät hinzufügen",
    addPackage: "Paket hinzufügen",
    addSession: "Sitzung eintragen",
    addStaff: "Personal hinzufügen",
    addPayment: "Zahlung hinzufügen",
    sessionCompleted: "Sitzung abgeschlossen",
    noRecord: "Noch keine Einträge.",
    localNotice: "Dieser Bereich ist mit der Datenbank verbunden. Einträge werden in Beauty PRO Tabellen gespeichert.",
  },
};

const CONTENT_LANGS = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];

const emptyCategory = {
  title_tr: "",
  title_en: "",
  title_de: "",
  aktif: true,
  sira: 0,
};

const emptyService = {
  category_id: "",

  title_tr: "",
  title_en: "",
  title_de: "",

  description_tr: "",
  description_en: "",
  description_de: "",

  price_tr: "",
  price_en: "",
  price_de: "",

  currency_tr: "TRY",
  currency_en: "USD",
  currency_de: "EUR",

  duration: "",

  image: "",
  is_featured: false,
  aktif: true,
};

const emptyFaq = {
  question_tr: "",
  question_en: "",
  question_de: "",
  answer_tr: "",
  answer_en: "",
  answer_de: "",
  aktif: true,
  sira: 0,
};

const emptyCustomer = {
  full_name: "",
  phone: "",
  email: "",
  birth_date: "",
  address: "",
  city: "",
  gender: "female",
  note: "",
  aktif: true,
};

const emptyDevice = {
  name: "",
  description: "",
  area_name: "",
  price_female: "",
  price_male: "",
  currency: "TRY",
  aktif: true,
};
const emptyPackage = {
  customer_id: "",
  customer_name: "",
  package_title: "",
  total_sessions: "10",
  sale_price: "",
  paid_amount: "",
  currency: "TRY",
  sale_date: new Date().toISOString().slice(0, 10),
  due_date: "",
  package_start_date: "",
  package_end_date: "",
  next_session_date: "",
  package_period_months: "3",
  note: "",
};
const emptyStaff = { name: "", expertise: "", phone: "", aktif: true };
const emptyPayment = {
  customer_id: "",
  customer_name: "",
  amount: "",
  currency: "TRY",
  type: "cash",
  note: "",
  payment_date: new Date().toISOString().slice(0, 10),
};
const emptySession = {
  customer_name: "",
  package_name: "",
  customer_package_id: "",
  session_date: new Date().toISOString().slice(0, 10),
  session_time: "",
  staff_name: "",
  note: "",
};
const emptyAppointmentForm = {
  customer_id: "",
  customer_name: "",
  customer_phone: "",

  appointment_type_id: "",
  appointment_type_title: "",

  category_id: "",
  service_id: "",
  service_name: "",
  staff_name: "",

  appointment_date: new Date().toISOString().slice(0, 10),
  appointment_time: "",
  duration: "30",
  note: "",
};
const emptyAppointmentType = {
  title: "",
  start_time: "09:00",
  end_time: "18:00",
  slot_minutes: "30",
  aktif: true,
  sira: 0,
};

export default function BeatyPanel() {
  const [activeTab, setActiveTab] = useState("services");
  const [uiLang, setUiLang] = useState("tr");
  const [formLang, setFormLang] = useState("tr");

  const [aktifDiller, setAktifDiller] = useState(["tr", "en", "de"]);
  const TT = TEXT[uiLang] || TEXT.tr;
const [beatyLangs, setBeatyLangs] = useState(["tr", "en", "de"]);

const contentLangs = CONTENT_LANGS.filter((l) =>
  beatyLangs.includes(l.code)
);

  useEffect(() => {
    if (["tr", "en", "de"].includes(uiLang)) {
      setFormLang(uiLang);
    }
  }, [uiLang]);

  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [appointments, setAppointments] = useState([]);

  const [customersPro, setCustomersPro] = useState([]);
  const [devicesPro, setDevicesPro] = useState([]);
  const [packagesPro, setPackagesPro] = useState([]);
  const [staffPro, setStaffPro] = useState([]);
  const [paymentsPro, setPaymentsPro] = useState([]);
  const [sessionsPro, setSessionsPro] = useState([]);

  const [customerForm, setCustomerForm] = useState(emptyCustomer);
const [customerSearch, setCustomerSearch] = useState("");
  const [deviceForm, setDeviceForm] = useState(emptyDevice);
  const [packageForm, setPackageForm] = useState(emptyPackage);
  const [staffForm, setStaffForm] = useState(emptyStaff);
  const [paymentForm, setPaymentForm] = useState(emptyPayment);
const [sessionForm, setSessionForm] = useState(emptySession);
const [appointmentForm, setAppointmentForm] = useState(emptyAppointmentForm);

const [appointmentTypes, setAppointmentTypes] = useState([]);
const [appointmentTypeForm, setAppointmentTypeForm] = useState(emptyAppointmentType);
const [editingAppointmentTypeId, setEditingAppointmentTypeId] = useState(null);

const [appointmentReportFilter, setAppointmentReportFilter] = useState("all");

const [reportStartDate, setReportStartDate] = useState("");
const [reportEndDate, setReportEndDate] = useState("");
const [dailyScheduleDate, setDailyScheduleDate] = useState(
  new Date().toISOString().slice(0, 10)
);
const [customerAccountSearch, setCustomerAccountSearch] = useState("");
const [customerAccountGender, setCustomerAccountGender] = useState("all");
const [customerAccountStatus, setCustomerAccountStatus] = useState("all");
const [customerAccountStartDate, setCustomerAccountStartDate] = useState("");
const [customerAccountEndDate, setCustomerAccountEndDate] = useState("");

  const [categoryForm, setCategoryForm] = useState(emptyCategory);
  const [serviceForm, setServiceForm] = useState(emptyService);
  const [faqForm, setFaqForm] = useState(emptyFaq);

  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [editingServiceId, setEditingServiceId] = useState(null);
  const [editingFaqId, setEditingFaqId] = useState(null);

  const [serviceImagePreview, setServiceImagePreview] = useState("");
const [googleReviewForm, setGoogleReviewForm] = useState({
  google_review_url: "",
  google_review_active: false,
  google_review_title_tr: "Bizi Google’da Değerlendirin",
  google_review_title_en: "Review us on Google",
  google_review_title_de: "Bewerten Sie uns auf Google",
  google_review_desc_tr: "Deneyiminizi paylaşarak bizi destekleyebilirsiniz.",
  google_review_desc_en: "You can support us by sharing your experience.",
  google_review_desc_de: "Sie können uns unterstützen, indem Sie Ihre Erfahrung teilen.",
});

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const res = await fetch(`${API_BASE}/kurum-ayarlar`, {
            headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const json = await res.json();
            const data = json?.data || null;

           if (data) {
  setGoogleReviewForm({
    google_review_url: data.google_review_url || "",
    google_review_active: data.google_review_active === true,
    google_review_title_tr: data.google_review_title_tr || "Bizi Google’da Değerlendirin",
    google_review_title_en: data.google_review_title_en || "Review us on Google",
    google_review_title_de: data.google_review_title_de || "Bewerten Sie uns auf Google",
    google_review_desc_tr: data.google_review_desc_tr || "Deneyiminizi paylaşarak bizi destekleyebilirsiniz.",
    google_review_desc_en: data.google_review_desc_en || "You can support us by sharing your experience.",
    google_review_desc_de: data.google_review_desc_de || "Sie können uns unterstützen, indem Sie Ihre Erfahrung teilen.",
  });

  let aktif = data.aktif_diller;

              if (typeof aktif === "string") {
                try {
                  aktif = JSON.parse(aktif);
                } catch {
                  aktif = ["tr", "en", "de"];
                }
              }

              if (Array.isArray(aktif) && aktif.length) {
                setAktifDiller(aktif.filter((x) => ["tr", "en", "de"].includes(x)));
              }

              const candidate = (
                localStorage.getItem("panel_dili") ||
                localStorage.getItem("app_lang") ||
                localStorage.getItem("lang") ||
                "tr"
              )
                .slice(0, 2)
                .toLowerCase();

              if (candidate && ["tr", "en", "de"].includes(candidate)) {
                setUiLang(candidate);
              }
            }
          }
        }
      } catch (err) {
        console.error("Ayarlar yüklenemedi:", err);
      }
    };

    loadSettings();
  }, []);

  useEffect(() => {
    const sync = () => {
      const l = (
        localStorage.getItem("panel_dili") ||
        localStorage.getItem("app_lang") ||
        localStorage.getItem("lang") ||
        "tr"
      )
        .slice(0, 2)
        .toLowerCase();

      if (["tr", "en", "de"].includes(l)) {
        setUiLang(l);
      }
    };

    sync();
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("app_settings_change", sync);
    window.addEventListener("storage", sync);

    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("app_settings_change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const loadAll = async () => {
    setLoading(true);

    try {
     const [
  catRes,
  srvRes,
  faqRes,
  appRes,
  appointmentTypesRes,
  customersRes,
        devicesRes,
        devicePricesRes,
        packagesRes,
        customerPackagesRes,
        sessionsRes,
        staffRes,
        paymentsRes,
        reportRes,
      ] = await Promise.all([
        fetch(`${API_BASE}/beaty/categories`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/services`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/faqs`, { headers: tokenHeader() }),
     fetch(`${API_BASE}/beaty/appointments`, { headers: tokenHeader() }),
fetch(`${API_BASE}/beaty/pro/appointment-types`, { headers: tokenHeader() }),

fetch(`${API_BASE}/beaty/pro/customers`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/devices`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/device-prices`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/packages`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/customer-packages`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/sessions`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/staff`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/payments`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/beaty/pro/reports/summary`, { headers: tokenHeader() }),
      ]);

      const catJson = await catRes.json().catch(() => ({}));
      const srvJson = await srvRes.json().catch(() => ({}));
      const faqJson = await faqRes.json().catch(() => ({}));
      const appJson = await appRes.json().catch(() => ({}));
const appointmentTypesJson = await appointmentTypesRes.json().catch(() => ({}));

      const customersJson = await customersRes.json().catch(() => ({}));
      const devicesJson = await devicesRes.json().catch(() => ({}));
      const devicePricesJson = await devicePricesRes.json().catch(() => ({}));
      const packagesJson = await packagesRes.json().catch(() => ({}));
      const customerPackagesJson = await customerPackagesRes.json().catch(() => ({}));
      const sessionsJson = await sessionsRes.json().catch(() => ({}));
      const staffJson = await staffRes.json().catch(() => ({}));
      const paymentsJson = await paymentsRes.json().catch(() => ({}));
      const reportJson = await reportRes.json().catch(() => ({}));

      setCategories(catJson.data || []);
      setServices(srvJson.data || []);
      setFaqs(faqJson.data || []);
      setAppointments(appJson.data || []);
setAppointmentTypes(appointmentTypesJson.data || []);

      const apiCustomers = customersJson.data || [];
      const apiDevices = devicesJson.data || [];
      const apiDevicePrices = devicePricesJson.data || [];
      const apiCustomerPackages = customerPackagesJson.data || [];

    setCustomersPro(apiCustomers.map((c) => ({
  ...c,
  name: c.full_name || c.name || "",
  genderText: c.gender === "male" ? TT.male : TT.female,
  birth_date: c.birth_date ? dateOnly(c.birth_date) : "",
  email: c.email || "",
  address: c.address || "",
  city: c.city || "",
})));

const devicePriceRows = [];

apiDevices.forEach((device) => {
  const prices = apiDevicePrices.filter(
    (p) => String(p.device_id) === String(device.id)
  );

  const areas = [...new Set(prices.map((p) => p.area_name || "-"))];

  if (areas.length === 0) {
    devicePriceRows.push({
      id: device.id,
      name: device.name || "-",
      area: device.description || "-",
      price_female: "-",
      price_male: "-",
      currency: "-",
    });
  } else {
    areas.forEach((area) => {
      const female = prices.find(
        (p) => p.area_name === area && p.gender === "female"
      );
      const male = prices.find(
        (p) => p.area_name === area && p.gender === "male"
      );

      devicePriceRows.push({
id: `device-${device.id}-${area}`,
        name: device.name || "-",
        area,
        price_female: female?.price || "-",
        price_male: male?.price || "-",
        currency: female?.currency || male?.currency || "TRY",
      });
    });
  }
});

setDevicesPro(devicePriceRows);

      setPackagesPro(apiCustomerPackages.map((pkg) => ({
        ...pkg,
        customer_name: pkg.full_name || pkg.customer_name || "-",
        package_name: pkg.package_title || pkg.package_name || "-",
        amount: pkg.sale_price || 0,
        paid: pkg.paid_amount || 0,
        used_sessions: pkg.used_sessions || 0,
        total_sessions: pkg.total_sessions || 0,
      })));

   setSessionsPro((sessionsJson.data || []).map((s) => ({
  ...s,
  customer_name: s.full_name || "-",
  package_name: s.package_title || "-",

  created_at: dateOnly(s.session_date || s.created_at),
  session_date_text: dateOnly(s.session_date || s.created_at),

  session_time: s.session_time || "-",
  staff_name: s.staff_name || "-",
})));

      setStaffPro((staffJson.data || []).map((x) => ({
        ...x,
        name: x.full_name || "",
        expertise: x.role || "",
      })));

      setPaymentsPro((paymentsJson.data || []).map((p) => ({
        ...p,
        customer_name: p.full_name || "-",
        created_at: p.payment_date || p.created_at,
      })));

      if (reportJson.data) {
        // Backend raporu gelirse ileride grafiklerde kullanılabilir.
      }
    } catch (err) {
      console.error("Beaty panel load error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  const getLocalized = (item, field) => {
    const value = item?.[`${field}_${uiLang}`];

    if (value && String(value).trim() !== "") {
      return value;
    }

    const trValue = item?.[`${field}_tr`];
    if (trValue && String(trValue).trim() !== "") {
      return `${trValue} (${uiLang.toUpperCase()} ${TT.emptyLang})`;
    }

    const enValue = item?.[`${field}_en`];
    if (enValue && String(enValue).trim() !== "") {
      return `${enValue} (${uiLang.toUpperCase()} ${TT.emptyLang})`;
    }

    const deValue = item?.[`${field}_de`];
    if (deValue && String(deValue).trim() !== "") {
      return `${deValue} (${uiLang.toUpperCase()} ${TT.emptyLang})`;
    }

    return "-";
  };
const saveGoogleReviewSettings = async () => {
  await fetch(`${API_BASE}/beaty/settings`, {
    method: "PUT",
    headers: tokenHeader(),
    body: JSON.stringify({
      beauty_enabled: true,
      beaty_enabled: true,
      ...googleReviewForm,
      google_review_active:
        googleReviewForm.google_review_active === true &&
        googleReviewForm.google_review_url.trim() !== "",
    }),
  });

  alert(TT.googleReviewSaved);
};
  const saveCategory = async () => {
    const url = editingCategoryId
      ? `${API_BASE}/beaty/categories/${editingCategoryId}`
      : `${API_BASE}/beaty/categories`;

    await fetch(url, {
      method: editingCategoryId ? "PUT" : "POST",
      headers: tokenHeader(),
      body: JSON.stringify(categoryForm),
    });

    setCategoryForm(emptyCategory);
    setEditingCategoryId(null);
    loadAll();
  };

  const saveService = async () => {
    if (!serviceForm.category_id) {
      alert(TT.pleaseSelectCategory);
      return;
    }

    const url = editingServiceId
      ? `${API_BASE}/beaty/services/${editingServiceId}`
      : `${API_BASE}/beaty/services`;

    await fetch(url, {
      method: editingServiceId ? "PUT" : "POST",
      headers: tokenHeader(),
      body: JSON.stringify(serviceForm),
    });

    setServiceForm(emptyService);
    setEditingServiceId(null);
    setServiceImagePreview("");
    loadAll();
  };

  const saveFaq = async () => {
    const url = editingFaqId
      ? `${API_BASE}/beaty/faqs/${editingFaqId}`
      : `${API_BASE}/beaty/faqs`;

    await fetch(url, {
      method: editingFaqId ? "PUT" : "POST",
      headers: tokenHeader(),
      body: JSON.stringify(faqForm),
    });

    setFaqForm(emptyFaq);
    setEditingFaqId(null);
    loadAll();
  };

  const deleteItem = async (type, id) => {
    if (!window.confirm(TT.confirmDelete)) return;

    await fetch(`${API_BASE}/beaty/${type}/${id}`, {
      method: "DELETE",
      headers: tokenHeader(),
    });

    loadAll();
  };

const updateAppointmentStatus = async (id, status) => {
  await fetch(`${API_BASE}/beaty/appointments/${id}/status`, {
    method: "PUT",
    headers: tokenHeader(),
    body: JSON.stringify({ status }),
  });

  loadAll();
};

const saveAppointmentType = async () => {
  if (!appointmentTypeForm.title || appointmentTypeForm.title.trim() === "") {
    alert("Randevu türü adı zorunlu");
    return;
  }

  const url = editingAppointmentTypeId
    ? `${API_BASE}/beaty/pro/appointment-types/${editingAppointmentTypeId}`
    : `${API_BASE}/beaty/pro/appointment-types`;

  const method = editingAppointmentTypeId ? "PUT" : "POST";

  try {
    const res = await fetch(url, {
      method,
      headers: tokenHeader(),
      body: JSON.stringify({
        title: appointmentTypeForm.title || "",
        start_time: appointmentTypeForm.start_time || "09:00",
        end_time: appointmentTypeForm.end_time || "18:00",
        slot_minutes: Number(appointmentTypeForm.slot_minutes || 30),
        aktif: appointmentTypeForm.aktif !== false,
        sira: Number(appointmentTypeForm.sira || 0),
      }),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json.ok === false) {
      alert(json.message || "Randevu türü kaydedilemedi");
      return;
    }

    setAppointmentTypeForm(emptyAppointmentType);
    setEditingAppointmentTypeId(null);
    loadAll();
  } catch (err) {
    console.error("Randevu türü kayıt hatası:", err);
    alert("Sunucuya bağlanılamadı");
  }
};

const editAppointmentType = (item) => {
  setEditingAppointmentTypeId(item.id);
  setAppointmentTypeForm({
    title: item.title || "",
    start_time: String(item.start_time || "09:00").slice(0, 5),
    end_time: String(item.end_time || "18:00").slice(0, 5),
    slot_minutes: String(item.slot_minutes || 30),
    aktif: item.aktif !== false,
    sira: Number(item.sira || 0),
  });
};

const deleteAppointmentType = async (id) => {
  if (!window.confirm("Bu randevu türünü silmek istiyor musun?")) return;

  try {
    const res = await fetch(`${API_BASE}/beaty/pro/appointment-types/${id}`, {
      method: "DELETE",
      headers: tokenHeader(),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json.ok === false) {
      alert(json.message || "Randevu türü silinemedi");
      return;
    }

    loadAll();
  } catch (err) {
    console.error("Randevu türü silme hatası:", err);
    alert("Sunucuya bağlanılamadı");
  }
};


function timeToMinutes(time) {
  const [h, m] = String(time || "00:00")
    .slice(0, 5)
    .split(":")
    .map(Number);

  if (Number.isNaN(h) || Number.isNaN(m)) return 0;
  return h * 60 + m;
}

function minutesToTime(total) {
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

function generateAppointmentSlots(startTime, endTime, slotMinutes) {
  const start = timeToMinutes(startTime || "09:00");
  const end = timeToMinutes(endTime || "18:00");
  const step = Number(slotMinutes || 30);

  if (!step || step <= 0 || end <= start) return [];

  const slots = [];

  for (let minute = start; minute < end; minute += step) {
    slots.push(minutesToTime(minute));
  }

  return slots;
}

const selectedAppointmentType = useMemo(() => {
  return appointmentTypes.find(
    (t) => String(t.id) === String(appointmentForm.appointment_type_id)
  );
}, [appointmentTypes, appointmentForm.appointment_type_id]);

const appointmentTimeOptions = useMemo(() => {
  if (!selectedAppointmentType) return [];

  return generateAppointmentSlots(
    selectedAppointmentType.start_time,
    selectedAppointmentType.end_time,
    selectedAppointmentType.slot_minutes
  );
}, [selectedAppointmentType]);

const getAppointmentConflict = (timeValue) => {
  const dateValue = appointmentForm.appointment_date;
  const clock = String(timeValue || "").slice(0, 5);
  const selectedStaff = String(appointmentForm.staff_name || "")
    .trim()
    .toLowerCase();

  if (!dateValue || !clock) return null;

  return appointments.find((a) => {
    const sameDate = dateOnly(a.appointment_date) === dateValue;
    const sameTime = String(a.appointment_time || "").slice(0, 5) === clock;

    const status = String(a.status || "new").toLowerCase();
    const activeStatus = !["completed", "cancelled", "canceled"].includes(status);

    const noteText = String(a.note || "").toLowerCase();
    const sameStaff =
      !selectedStaff || noteText.includes(`personel: ${selectedStaff}`);

    return sameDate && sameTime && activeStatus && sameStaff;
  });
};

const saveAppointmentManual = async () => {
  if (!appointmentForm.customer_name) {
    alert("Müşteri seçmelisin");
    return;
  }

  if (!appointmentForm.appointment_type_id) {
    alert("Randevu türü seçmelisin");
    return;
  }

  if (!appointmentForm.appointment_date || !appointmentForm.appointment_time) {
    alert("Randevu tarihi ve saati zorunlu");
    return;
  }

  if (
    selectedAppointmentType &&
    !appointmentTimeOptions.includes(String(appointmentForm.appointment_time).slice(0, 5))
  ) {
    alert("Seçilen saat bu randevu türünün saat aralığında değil.");
    return;
  }

  const conflict = getAppointmentConflict(appointmentForm.appointment_time);

  if (conflict) {
    const devam = window.confirm(
      `Uyarı: Bu tarih ve saatte başka bir randevu var.\n\n` +
        `Müşteri: ${conflict.customer_name || "-"}\n` +
        `Saat: ${String(conflict.appointment_time || "").slice(0, 5)}\n\n` +
        `Yine de randevuyu kaydetmek istiyor musun?`
    );

    if (!devam) return;
  }

  const res = await fetch(`${API_BASE}/beaty/appointments`, {
    method: "POST",
    headers: tokenHeader(),
    body: JSON.stringify({
      service_id: appointmentForm.service_id || null,
      customer_name: appointmentForm.customer_name,
      customer_phone: appointmentForm.customer_phone || "",
      appointment_date: appointmentForm.appointment_date,
      appointment_time: appointmentForm.appointment_time,
      note: [
        appointmentForm.appointment_type_title
          ? `Randevu Türü: ${appointmentForm.appointment_type_title}`
          : "",
        appointmentForm.service_name ? `Hizmet: ${appointmentForm.service_name}` : "",
        appointmentForm.staff_name ? `Personel: ${appointmentForm.staff_name}` : "",
        appointmentForm.duration ? `Süre: ${appointmentForm.duration} dk` : "",
        appointmentForm.note || "",
      ]
        .filter(Boolean)
        .join(" | "),
      status: "new",
    }),
  });

  const json = await res.json().catch(() => ({}));

  if (!res.ok || json.ok === false) {
    alert(json.message || "Randevu kaydedilemedi");
    return;
  }

  alert(conflict ? "Uyarıya rağmen randevu kaydedildi" : "Randevu kaydedildi");
  setAppointmentForm(emptyAppointmentForm);
  loadAll();
};



const postPro = async (url, body) => {
  try {
    console.log("🔥 PRO POST GİDİYOR:", `${API_BASE}${url}`, body);

    const res = await fetch(`${API_BASE}${url}`, {
      method: "POST",
      headers: tokenHeader(),
      body: JSON.stringify(body),
    });

    const json = await res.json().catch(() => ({}));

    console.log("🔥 PRO POST CEVAP:", res.status, json);

    if (!res.ok || json.ok === false) {
      alert(json.message || "Kayıt yapılamadı");
      return false;
    }

    await loadAll();
    return true;
  } catch (err) {
    console.error("🔥 PRO POST FETCH ERROR:", err);
    alert("Sunucuya istek gönderilemedi");
    return false;
  }
};

const syncBeautyCustomerToCari = async (payload = {}) => {
  try {
    if (!payload.full_name && !payload.name) return false;

    const res = await fetch(`${API_BASE}/cari/customers`, {
      method: "POST",
      headers: tokenHeader(),
      body: JSON.stringify({
        full_name: payload.full_name || payload.name || "",
        phone: payload.phone || "",
        email: payload.email || "",
        gender: payload.gender || "female",
        birth_date: payload.birth_date || null,
        city: payload.city || "",
        address: payload.address || "",
        note: payload.note || "Beauty modülünden otomatik aktarıldı",
        source_module: "beaty",
        customer_type: "general",
        whatsapp_opt_in: true,
        aktif: payload.aktif !== false,
      }),
    });

    const json = await res.json().catch(() => ({}));

    // Aynı kişi varsa hata gibi davranma, akışı bozma.
    if (!res.ok || json.ok === false) {
      console.warn("Cari eşitleme uyarısı:", json.message || json);
      return false;
    }

    return true;
  } catch (err) {
    console.warn("Cari eşitleme yapılamadı:", err);
    return false;
  }
};

const refreshCariFromBeauty = async () => {
  try {
    await fetch(`${API_BASE}/cari/import-beaty`, {
      method: "POST",
      headers: tokenHeader(),
    });
  } catch (err) {
    console.warn("Beauty -> Cari otomatik aktarım yapılamadı:", err);
  }
};


  const deletePro = async (url) => {
    if (!window.confirm(TT.confirmDelete)) return;

    const res = await fetch(`${API_BASE}${url}`, {
      method: "DELETE",
      headers: tokenHeader(),
    });

    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.ok === false) {
      alert(json.message || "Silme işlemi yapılamadı");
      return;
    }

    loadAll();
  };

const saveCustomerPro = async () => {
   console.log("MÜŞTERİ KAYIT DENEME:", customerForm);

  if (!customerForm.full_name || customerForm.full_name.trim() === "") {
    alert("Müşteri adı zorunlu");
    return;
  }

const payload = {
  full_name: customerForm.full_name.trim(),
  phone: customerForm.phone || "",
  email: customerForm.email || "",
  birth_date: customerForm.birth_date || null,
  address: customerForm.address || "",
  city: customerForm.city || "",
  gender: customerForm.gender || "female",
  note: customerForm.note || "",
  aktif: true,
};

const ok = await postPro("/beaty/pro/customers", payload);

if (ok) {
  // Çift kayıt oluşmasın diye sadece tek merkezden Cari’ye aktar.
  // /cari/import-beaty zaten Beauty müşterisini Cari ile eşitliyor.
  await refreshCariFromBeauty();

  setCustomerForm(emptyCustomer);
  loadAll();
}

};

const printCustomerPro = (customer) => {
  const customerPackages = packagesPro.filter(
    (p) => String(p.customer_id) === String(customer.id) || p.customer_name === customer.name
  );

  const customerSessions = sessionsPro.filter(
    (s) => String(s.customer_id) === String(customer.id) || s.customer_name === customer.name
  );

  const customerPayments = paymentsPro.filter(
    (p) => String(p.customer_id) === String(customer.id) || p.customer_name === customer.name
  );

  const html = `
    <html>
      <head>
        <title>${customer.name} - Müşteri Kartı</title>
        <style>
          body { font-family: Arial; padding: 30px; color: #111; }
          h1 { color: #be185d; }
          table { width: 100%; border-collapse: collapse; margin-top: 15px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background: #f3f4f6; }
        </style>
      </head>
      <body>
        <h1>Müşteri Kartı</h1>
        <p><b>Ad:</b> ${customer.name || "-"}</p>
        <p><b>Telefon:</b> ${customer.phone || "-"}</p>
        <p><b>Cinsiyet:</b> ${customer.gender || "-"}</p>
        <p><b>Not:</b> ${customer.note || "-"}</p>

        <h2>Paketler</h2>
        <table>
          <tr><th>Paket</th><th>Toplam</th><th>Kullanılan</th><th>Kalan</th><th>Borç</th></tr>
          ${customerPackages.map(p => `
            <tr>
              <td>${p.package_name || "-"}</td>
              <td>${p.total_sessions || 0}</td>
              <td>${p.used_sessions || 0}</td>
              <td>${p.remaining_sessions || 0}</td>
              <td>${p.debt_amount || 0} ${p.currency || ""}</td>
            </tr>
          `).join("")}
        </table>

        <h2>Seanslar</h2>
        <table>
          <tr><th>Tarih</th><th>Paket</th><th>Not</th></tr>
          ${customerSessions.map(s => `
            <tr>
              <td>${s.created_at || "-"}</td>
              <td>${s.package_name || "-"}</td>
              <td>${s.note || "-"}</td>
            </tr>
          `).join("")}
        </table>

        <h2>Tahsilatlar</h2>
        <table>
          <tr><th>Tarih</th><th>Tutar</th><th>Not</th></tr>
          ${customerPayments.map(p => `
            <tr>
              <td>${p.created_at || "-"}</td>
              <td>${p.amount || 0} ${p.currency || ""}</td>
              <td>${p.note || "-"}</td>
            </tr>
          `).join("")}
        </table>
      </body>
    </html>
  `;

  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
  w.print();
};

const saveDevicePro = async () => {
    if (!deviceForm.name) return;

    const ok = await postPro("/beaty/pro/devices", {
      name: deviceForm.name,
      description: deviceForm.description || "",
      aktif: true,
    });

if (ok && deviceForm.area_name) {

      // Aynı alana kadın ve erkek fiyatını ayrı satır olarak kaydediyoruz.
      const createdDeviceRes = await fetch(`${API_BASE}/beaty/pro/devices`, { headers: tokenHeader() });
      const createdDeviceJson = await createdDeviceRes.json().catch(() => ({}));
      const createdDevice = (createdDeviceJson.data || []).find((d) => d.name === deviceForm.name);
      const deviceId = createdDevice?.id || null;

      if (deviceId && deviceForm.price_female) {
        await postPro("/beaty/pro/device-prices", {
          device_id: deviceId,
area_name: deviceForm.area_name,
          gender: "female",
          price: deviceForm.price_female,
          currency: deviceForm.currency,
        });
      }

      if (deviceId && deviceForm.price_male) {
        await postPro("/beaty/pro/device-prices", {
          device_id: deviceId,
area_name: deviceForm.area_name,
          gender: "male",
          price: deviceForm.price_male,
          currency: deviceForm.currency,
        });
      }
    }

    if (ok) setDeviceForm(emptyDevice);
    loadAll();
  };



const savePackagePro = async () => {
  if (!packageForm.customer_name && !packageForm.package_title) return;

  let customer = customersPro.find(
    (c) =>
      String(c.name || "").toLowerCase() ===
      String(packageForm.customer_name || "").toLowerCase()
  );

  if (!customer && packageForm.customer_name) {
    await postPro("/beaty/pro/customers", {
      full_name: packageForm.customer_name,
      phone: "",
      gender: "female",
      note: "Paket satışı sırasında oluşturuldu",
      aktif: true,
    });

    const customerRes = await fetch(`${API_BASE}/beaty/pro/customers`, {
      headers: tokenHeader(),
    });

    const customerJson = await customerRes.json().catch(() => ({}));

    customer = (customerJson.data || []).find(
      (c) =>
        String(c.full_name || "").toLowerCase() ===
        String(packageForm.customer_name || "").toLowerCase()
    );
  }

  const customerId = packageForm.customer_id || customer?.id || null;

  if (!customerId) {
    alert("Müşteri bulunamadı. Önce müşteri seçmelisin.");
    return;
  }

  try {
    const packageRes = await fetch(`${API_BASE}/beaty/pro/customer-packages`, {
      method: "POST",
      headers: tokenHeader(),
      body: JSON.stringify({
        customer_id: customerId,
        package_id: null,
        package_title: packageForm.package_title || "",
        total_sessions: packageForm.total_sessions || 1,
        sale_price: packageForm.sale_price || 0,
paid_amount: 0,
        currency: packageForm.currency || "TRY",

        sale_date: packageForm.sale_date || null,
        package_start_date: packageForm.package_start_date || null,
        package_end_date: packageForm.package_end_date || null,
        next_session_date: packageForm.next_session_date || null,
        package_period_months: packageForm.package_period_months || "",

        note: packageForm.note || "",
      }),
    });

    const packageJson = await packageRes.json().catch(() => ({}));

    if (!packageRes.ok || packageJson.ok === false) {
      alert(packageJson.message || "Paket kaydedilemedi");
      return;
    }

    const createdPackage =
      packageJson.data ||
      packageJson.row ||
      packageJson.package ||
      null;

    const createdPackageId =
      createdPackage?.id ||
      packageJson.id ||
      null;

    const paidAmount = Number(packageForm.paid_amount || 0);

    // Paket satışı sırasında ödeme girildiyse bu gerçek tahsilattır.
    // Direkt /cash kaydı atma. Beauty tahsilatına gönder.
    // Backend bunu cariye, rapora ve kasaya işler.
    if (paidAmount > 0) {
      const payRes = await fetch(`${API_BASE}/beaty/pro/payments`, {
        method: "POST",
        headers: tokenHeader(),
        body: JSON.stringify({
          customer_id: customerId,
          customer_package_id: createdPackageId,
          amount: paidAmount,
          currency: packageForm.currency || "TRY",
          payment_type: "cash",
          payment_method: "cash",
          note: `Paket satışı tahsilatı: ${packageForm.package_title || ""}`,
          payment_date:
            packageForm.sale_date || new Date().toISOString().slice(0, 10),
        }),
      });

      const payJson = await payRes.json().catch(() => ({}));

      if (!payRes.ok || payJson.ok === false) {
        alert(
          payJson.message ||
            "Paket kaydedildi ama tahsilat kasaya işlenemedi"
        );
      }
    }

   await refreshCariFromBeauty();

setPackageForm(emptyPackage);
loadAll();

  } catch (err) {
    console.error("Paket kayıt hatası:", err);
    alert("Sunucuya bağlanılamadı");
  }
};


  const completeSession = async () => {
  const selectedPackage = packagesPro.find(
  (pkg) => String(pkg.id) === String(sessionForm.customer_package_id)
);

    if (!selectedPackage) {
      alert("Müşteri paketi bulunamadı. Önce paket satışı oluştur.");
      return;
    }

    const ok = await postPro("/beaty/pro/sessions/use", {
      customer_package_id: selectedPackage.id,
      customer_id: selectedPackage.customer_id,
   session_date: sessionForm.session_date || new Date().toISOString().slice(0, 10),
session_time: sessionForm.session_time || "",
staff_name: sessionForm.staff_name || "",
note: sessionForm.note || "",
      status: "completed",
    });

    if (ok) {
      setSessionForm(emptySession);
      alert(TT.sessionCompleted);
    }
  };

  const saveStaffPro = async () => {
    if (!staffForm.name) return;

    const ok = await postPro("/beaty/pro/staff", {
      full_name: staffForm.name,
      phone: staffForm.phone,
      role: staffForm.expertise,
      aktif: true,
    });

    if (ok) setStaffForm(emptyStaff);
  };

 




const savePaymentPro = async () => {
  if (!paymentForm.customer_id) {
    alert("Müşteri seçmelisin");
    return;
  }

  if (!paymentForm.amount) {
    alert("Tutar girmelisin");
    return;
  }

  const customerPackage = packagesPro.find(
    (pkg) =>
      String(pkg.customer_id) === String(paymentForm.customer_id) &&
      Number(pkg.debt_amount || 0) > 0
  );

  const ok = await postPro("/beaty/pro/payments", {
    customer_id: paymentForm.customer_id,
    customer_package_id: customerPackage?.id || null,
    amount: paymentForm.amount || 0,
    currency: paymentForm.currency || "TRY",
    payment_type: paymentForm.type || "cash",
    note: paymentForm.note || "",
    payment_date:
      paymentForm.payment_date || new Date().toISOString().slice(0, 10),
  });

if (ok) {
  await refreshCariFromBeauty();
  setPaymentForm(emptyPayment);
}
};



const stats = useMemo(() => {
  return {
    categories: categories.length,
    services: services.length,
    faqs: faqs.length,
    appointments: appointments.length,
    newAppointments: appointments.filter((a) => a.status === "new").length,
    customers: customersPro.length,
    packages: packagesPro.length,
    payments: paymentsPro.length,
  };
}, [categories, services, faqs, appointments, customersPro, packagesPro, paymentsPro]);

const normalizeText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const getNoteValue = (note, key) => {
  const text = String(note || "");
  const target = String(key || "").toLowerCase();

  const part = text
    .split("|")
    .map((x) => x.trim())
    .find((x) => x.toLowerCase().startsWith(`${target}:`));

  if (!part) return "";

  return part.slice(part.indexOf(":") + 1).trim();
};

const getAppointmentTypeTitle = (appointment) => {
  return (
    appointment.appointment_type_title ||
    getNoteValue(appointment.note, "Randevu Türü") ||
    ""
  );
};

const getAppointmentStaffName = (appointment) => {
  return (
    appointment.staff_name ||
    getNoteValue(appointment.note, "Personel") ||
    "-"
  );
};

const getAppointmentServiceName = (appointment) => {
  return (
    appointment.service_name ||
    getNoteValue(appointment.note, "Hizmet") ||
    appointment.service_title_tr ||
    "-"
  );
};

const getAppointmentDurationText = (appointment) => {
  return getNoteValue(appointment.note, "Süre") || "";
};

const getAppointmentPackageFee = (appointment) => {
  const noteFee =
    getNoteValue(appointment.note, "Paket / Ücret") ||
    getNoteValue(appointment.note, "Paket") ||
    getNoteValue(appointment.note, "Ücret");

  if (noteFee) return noteFee;

  const service = services.find(
    (s) => String(s.id) === String(appointment.service_id)
  );

  if (!service) return "-";

  const price =
    service[`price_${uiLang}`] ||
    service.price_tr ||
    service.price ||
    "";

  const currency =
    service[`currency_${uiLang}`] ||
    service.currency_tr ||
    service.currency ||
    "";

  return price ? `${price} ${currency}` : "-";
};
const reportData = useMemo(() => {
  const inRange = (dateValue) => {
    if (!reportStartDate && !reportEndDate) return true;
    const d = dateOnly(dateValue);
    if (!d) return false;
    if (reportStartDate && d < reportStartDate) return false;
    if (reportEndDate && d > reportEndDate) return false;
    return true;
  };

  const filteredPackages = packagesPro.filter((p) => inRange(p.sale_date || p.created_at));
  const filteredPayments = paymentsPro.filter((p) => inRange(p.payment_date || p.created_at));
  const filteredSessions = sessionsPro.filter((s) => inRange(s.session_date || s.created_at));
const filteredAppointments = appointments.filter((a) =>
  inRange(a.appointment_date || a.created_at)
);

const dailyAppointments = appointments
  .filter((a) => dateOnly(a.appointment_date) === dailyScheduleDate)
  .sort((a, b) =>
    String(a.appointment_time || "").localeCompare(
      String(b.appointment_time || "")
    )
  );

const dailyScheduleGroups = appointmentTypes
  .filter((type) => type.aktif !== false)
  .map((type) => {
    const slots = generateAppointmentSlots(
      type.start_time || "09:00",
      type.end_time || "18:00",
      type.slot_minutes || 30
    );

    const typeTitle = normalizeText(type.title);

    const typeAppointments = dailyAppointments.filter(
      (a) => normalizeText(getAppointmentTypeTitle(a)) === typeTitle
    );

    const usedAppointmentIds = new Set();

    const slotRows = slots.map((time) => {
      const found = typeAppointments.find(
        (a) => String(a.appointment_time || "").slice(0, 5) === time
      );

      if (found) {
        usedAppointmentIds.add(found.id);
      }

      return {
        time,
        appointment: found || null,
        isExtra: false,
      };
    });

    const extraRows = typeAppointments
      .filter((a) => !usedAppointmentIds.has(a.id))
      .map((a) => ({
        time: String(a.appointment_time || "").slice(0, 5) || "-",
        appointment: a,
        isExtra: true,
      }));

    return {
      id: type.id,
      title: type.title || "Randevu Türü",
      start_time: String(type.start_time || "").slice(0, 5),
      end_time: String(type.end_time || "").slice(0, 5),
      slot_minutes: type.slot_minutes || 30,
      rows: [...slotRows, ...extraRows].sort(
        (a, b) => timeToMinutes(a.time) - timeToMinutes(b.time)
      ),
    };
  });

const groupedAppointmentIds = new Set();

dailyScheduleGroups.forEach((group) => {
  group.rows.forEach((row) => {
    if (row.appointment?.id) {
      groupedAppointmentIds.add(row.appointment.id);
    }
  });
});

const untypedDailyAppointments = dailyAppointments.filter(
  (a) => !groupedAppointmentIds.has(a.id)
);

  const totalSales = filteredPackages.reduce((sum, p) => sum + Number(p.amount || p.sale_price || 0), 0);
  const totalPayments = filteredPayments.reduce((sum, p) => sum + Number(p.amount || 0), 0);
  const totalDebt = filteredPackages.reduce((sum, p) => sum + Number(p.debt_amount || 0), 0);
  const totalSessions = filteredPackages.reduce((sum, p) => sum + Number(p.total_sessions || 0), 0);
  const usedSessions = filteredPackages.reduce((sum, p) => sum + Number(p.used_sessions || 0), 0);
  const remainingSessions = filteredPackages.reduce((sum, p) => sum + Number(p.remaining_sessions || 0), 0);

const completedAppointments = filteredAppointments.filter((a) => a.status === "completed").length;

const today = new Date().toISOString().slice(0, 10);
const next30 = new Date();
next30.setDate(next30.getDate() + 30);
const next30Date = next30.toISOString().slice(0, 10);

const upcomingAppointments = appointments
  .filter((a) => {
    const d = dateOnly(a.appointment_date);
    return d >= today && d <= next30Date;
  })
  .sort((a, b) =>
    String(a.appointment_date || "").localeCompare(String(b.appointment_date || ""))
  );

const upcomingBirthdays = customersPro
  .filter((c) => c.birth_date)
  .map((c) => {
    const birth = dateOnly(c.birth_date);
    const monthDay = birth.slice(5, 10);
    const thisYearDate = `${new Date().getFullYear()}-${monthDay}`;

    return {
      ...c,
      birthday_this_year: thisYearDate,
    };
  })
.filter(
  (c) =>
    c.birthday_this_year >= today &&
    c.birthday_this_year <= next30Date
)
.sort((a, b) =>
    String(a.birthday_this_year).localeCompare(String(b.birthday_this_year))
  );

return {
  filteredPackages,
  filteredPayments,
  filteredSessions,
  filteredAppointments,
  upcomingAppointments,
  upcomingBirthdays,
  dailyAppointments,
  dailyScheduleGroups,
  untypedDailyAppointments,

    totalSales,
    totalPayments,
    totalDebt,
    totalSessions,
    usedSessions,
    remainingSessions,
    collectionRate: totalSales > 0 ? Math.round((totalPayments / totalSales) * 100) : 0,
    sessionRate: totalSessions > 0 ? Math.round((usedSessions / totalSessions) * 100) : 0,
    debtRate: totalSales > 0 ? Math.round((totalDebt / totalSales) * 100) : 0,
    appointmentRate: filteredAppointments.length > 0 ? Math.round((completedAppointments / filteredAppointments.length) * 100) : 0,
  };
}, [
  packagesPro,
  paymentsPro,
  sessionsPro,
  appointments,
  appointmentTypes,
  services,
  customersPro,
  reportStartDate,
  reportEndDate,
  dailyScheduleDate,
  uiLang,
]);

const escapeHtml = (value) =>
  String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

const printDailyAppointmentSchedule = () => {
  const printDate = formatDate(dailyScheduleDate);
  const nowText = new Date().toLocaleString("tr-TR");

  const groupsHtml = reportData.dailyScheduleGroups
    .map((group) => {
      const rowsHtml = group.rows
        .map((row) => {
          const a = row.appointment;

          return `
            <tr class="${a ? "filled-row" : ""}">
              <td class="time-cell">${escapeHtml(row.time)}</td>
              <td>${escapeHtml(a?.customer_name || a?.name || "")}</td>
              <td>${escapeHtml(a?.customer_phone || a?.phone || "")}</td>
              <td>${escapeHtml(a ? getAppointmentStaffName(a) : "")}</td>
              <td>${escapeHtml(
                a
                  ? [
                      getAppointmentServiceName(a),
                      getAppointmentDurationText(a),
                      a.note || "",
                    ]
                      .filter(Boolean)
                      .join(" / ")
                  : ""
              )}</td>
              <td>${escapeHtml(a ? getAppointmentPackageFee(a) : "")}</td>
            </tr>
          `;
        })
        .join("");

      return `
        <div class="schedule-section">
          <h2>${escapeHtml(group.title)}</h2>
          <div class="section-meta">
            ${escapeHtml(group.start_time)} - ${escapeHtml(group.end_time)}
            / ${escapeHtml(group.slot_minutes)} dk aralık
          </div>

          <table>
            <thead>
              <tr>
                <th>Saat</th>
                <th>Ad Soyad</th>
                <th>Telefon</th>
                <th>Estetisyen</th>
                <th>Açıklama</th>
                <th>Paket / Ücret</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
        </div>
      `;
    })
    .join("");

  const untypedHtml =
    reportData.untypedDailyAppointments.length > 0
      ? `
        <div class="schedule-section">
          <h2>Türü Belirsiz Randevular</h2>
          <table>
            <thead>
              <tr>
                <th>Saat</th>
                <th>Ad Soyad</th>
                <th>Telefon</th>
                <th>Estetisyen</th>
                <th>Açıklama</th>
                <th>Paket / Ücret</th>
              </tr>
            </thead>
            <tbody>
              ${reportData.untypedDailyAppointments
                .map(
                  (a) => `
                    <tr class="filled-row">
                      <td class="time-cell">${escapeHtml(
                        String(a.appointment_time || "").slice(0, 5)
                      )}</td>
                      <td>${escapeHtml(a.customer_name || a.name || "")}</td>
                      <td>${escapeHtml(a.customer_phone || a.phone || "")}</td>
                      <td>${escapeHtml(getAppointmentStaffName(a))}</td>
                      <td>${escapeHtml(
                        [
                          getAppointmentServiceName(a),
                          getAppointmentDurationText(a),
                          a.note || "",
                        ]
                          .filter(Boolean)
                          .join(" / ")
                      )}</td>
                      <td>${escapeHtml(getAppointmentPackageFee(a))}</td>
                    </tr>
                  `
                )
                .join("")}
            </tbody>
          </table>
        </div>
      `
      : "";

  const html = `
    <html>
      <head>
        <title>Günlük Randevu Çizelgesi - ${escapeHtml(printDate)}</title>
        <style>
          * { box-sizing: border-box; }
          body {
            font-family: Arial, Helvetica, sans-serif;
            color: #111827;
            padding: 24px;
            background: #ffffff;
          }
          .header {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            border-bottom: 3px solid #111827;
            padding-bottom: 14px;
            margin-bottom: 18px;
            gap: 20px;
          }
          .brand {
            font-size: 22px;
            font-weight: 900;
            color: #92400e;
          }
          .title {
            text-align: center;
            flex: 1;
          }
          .title h1 {
            margin: 0;
            font-size: 26px;
            letter-spacing: .5px;
          }
          .title p {
            margin: 6px 0 0;
            font-weight: 700;
            color: #374151;
          }
          .date {
            font-size: 15px;
            font-weight: 800;
            text-align: right;
          }
          .summary {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
            margin: 16px 0 20px;
          }
          .summary-card {
            border: 1px solid #d1d5db;
            border-radius: 12px;
            padding: 10px;
            background: #f9fafb;
          }
          .summary-card span {
            display: block;
            color: #6b7280;
            font-size: 12px;
            font-weight: 700;
          }
          .summary-card b {
            display: block;
            font-size: 20px;
            margin-top: 4px;
          }
          .schedule-section {
            margin-top: 18px;
            page-break-inside: avoid;
          }
          .schedule-section h2 {
            text-align: center;
            margin: 0;
            padding: 8px;
            background: #111827;
            color: #ffffff;
            font-size: 18px;
            letter-spacing: .4px;
            border-radius: 8px 8px 0 0;
          }
          .section-meta {
            text-align: center;
            font-size: 12px;
            color: #4b5563;
            font-weight: 700;
            padding: 6px;
            border-left: 1px solid #111827;
            border-right: 1px solid #111827;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }
          th, td {
            border: 1px solid #111827;
            padding: 7px 6px;
            font-size: 12px;
            vertical-align: top;
            min-height: 28px;
            word-break: break-word;
          }
          th {
            background: #f3f4f6;
            font-size: 13px;
            font-weight: 900;
            text-align: center;
          }
          .time-cell {
            width: 70px;
            text-align: center;
            font-weight: 900;
            font-size: 14px;
          }
          .filled-row {
            background: #fff7ed;
          }
          @media print {
            body { padding: 0; }
            .schedule-section { page-break-inside: avoid; }
          }
        </style>
      </head>

      <body>
        <div class="header">
          <div class="brand">Beauty PRO</div>

          <div class="title">
            <h1>GÜNLÜK RANDEVU ÇİZELGESİ</h1>
            <p>Panel kayıtlarından otomatik oluşturulmuştur</p>
          </div>

          <div class="date">
            Tarih: ${escapeHtml(printDate)}<br />
            Çıktı: ${escapeHtml(nowText)}
          </div>
        </div>

        <div class="summary">
          <div class="summary-card">
            <span>Günlük Randevu</span>
            <b>${reportData.dailyAppointments.length}</b>
          </div>
          <div class="summary-card">
            <span>Yeni Talep</span>
            <b>${reportData.dailyAppointments.filter((a) => a.status === "new").length}</b>
          </div>
          <div class="summary-card">
            <span>Tamamlanan</span>
            <b>${reportData.dailyAppointments.filter((a) => a.status === "completed").length}</b>
          </div>
          <div class="summary-card">
            <span>Randevu Türü</span>
            <b>${reportData.dailyScheduleGroups.length}</b>
          </div>
        </div>

        ${groupsHtml || "<p>Bu tarih için randevu türü çizelgesi bulunamadı.</p>"}
        ${untypedHtml}
      </body>
    </html>
  `;

  const w = window.open("", "_blank");
  if (!w) {
    alert("Çıktı penceresi açılamadı. Tarayıcı popup iznini kontrol et.");
    return;
  }

  w.document.write(html);
  w.document.close();
  w.focus();

  setTimeout(() => {
    w.print();
  }, 400);
};

if (loading) {

    return <div style={styles.loading}>{TT.loading}</div>;
  }

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>{TT.title}</h1>
          <p style={styles.subtitle}>{TT.subtitle}</p>
        </div>
      </div>

      <div style={styles.statsGrid}>
        <Stat title={TT.category} value={stats.categories} />
        <Stat title={TT.service} value={stats.services} />
        <Stat title={TT.faqs} value={stats.faqs} />
        <Stat title={TT.newAppointment} value={stats.newAppointments} />
        <Stat title={TT.customers} value={stats.customers} />
        <Stat title={TT.packages} value={stats.packages} />
        <Stat title={TT.payments} value={stats.payments} />
      </div>

      <div style={styles.proBanner}>
        <div>
          <h2 style={styles.proBannerTitle}>{TT.proTitle}</h2>
          <p style={styles.proBannerText}>{TT.proSubtitle}</p>
        </div>
        <span style={styles.proBadge}>PRO</span>
      </div>
<div style={styles.card}>
  <h2 style={styles.cardTitle}>🌐 İçerik Dilleri</h2>

  <div style={styles.formLangTabs}>
    {CONTENT_LANGS.map((l) => (
      <button
        key={l.code}
        type="button"
        onClick={() => {
          setBeatyLangs((prev) => {
            if (prev.includes(l.code)) {
              if (prev.length === 1) return prev;
              return prev.filter((x) => x !== l.code);
            }
            return [...prev, l.code];
          });
        }}
        style={{
          ...styles.formLangBtn,
          ...(beatyLangs.includes(l.code) ? styles.formLangBtnActive : {}),
        }}
      >
        {l.label} {beatyLangs.includes(l.code) ? "✓" : ""}
      </button>
    ))}
  </div>
</div>

<div style={{ ...styles.card, marginTop: 18, marginBottom: 18 }}>
  <h2 style={styles.cardTitle}>{TT.googleReviewSettings}</h2>

  <div style={styles.grid3}>
    <Input
      label={TT.googleReviewUrl}
      value={googleReviewForm.google_review_url}
      onChange={(v) =>
        setGoogleReviewForm({
          ...googleReviewForm,
          google_review_url: v,
          google_review_active: v.trim() !== "",
        })
      }
    />
  </div>

  <LanguageTabs
    langs={contentLangs}
    active={formLang}
    setActive={setFormLang}
    record={{
      title_tr: googleReviewForm.google_review_title_tr,
      title_en: googleReviewForm.google_review_title_en,
      title_de: googleReviewForm.google_review_title_de,
      description_tr: googleReviewForm.google_review_desc_tr,
      description_en: googleReviewForm.google_review_desc_en,
      description_de: googleReviewForm.google_review_desc_de,
    }}
    fields={["title", "description"]}
  />

  <div style={styles.grid3}>
    <Input
      label={TT.googleReviewTitle}
      value={googleReviewForm[`google_review_title_${formLang}`]}
      onChange={(v) =>
        setGoogleReviewForm({
          ...googleReviewForm,
          [`google_review_title_${formLang}`]: v,
        })
      }
    />
  </div>

  <div style={styles.grid3}>
    <Textarea
      label={TT.googleReviewDesc}
      value={googleReviewForm[`google_review_desc_${formLang}`]}
      onChange={(v) =>
        setGoogleReviewForm({
          ...googleReviewForm,
          [`google_review_desc_${formLang}`]: v,
        })
      }
    />
  </div>

  <div style={styles.row}>
    <label style={styles.checkLabel}>
      <input
        type="checkbox"
        checked={
          googleReviewForm.google_review_active === true &&
          googleReviewForm.google_review_url.trim() !== ""
        }
        onChange={(e) =>
          setGoogleReviewForm({
            ...googleReviewForm,
            google_review_active: e.target.checked,
          })
        }
        disabled={googleReviewForm.google_review_url.trim() === ""}
      />
      {TT.googleReviewActive}
    </label>

    <button onClick={saveGoogleReviewSettings} style={styles.primaryBtn}>
      {TT.googleReviewSave}
    </button>
  </div>
</div>

      <div style={styles.tabs}>
        <Tab id="services" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.services} />
        <Tab id="categories" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.categories} />
        <Tab id="faqs" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.faqs} />
 <Tab id="appointments" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.appointments} />
<Tab id="appointmentCreate" activeTab={activeTab} setActiveTab={setActiveTab} label="Randevu Oluştur" />
<Tab id="appointmentTypes" activeTab={activeTab} setActiveTab={setActiveTab} label="Randevu Türleri" />

<Tab id="customers" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.customers} />
<Tab id="customerAccounts" activeTab={activeTab} setActiveTab={setActiveTab} label="Müşteri Cari" />
<Tab id="devices" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.devices} />

        <Tab id="packages" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.packages} />
        <Tab id="sessions" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.sessions} />
        <Tab id="staff" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.staff} />
        <Tab id="payments" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.payments} />
        <Tab id="reports" activeTab={activeTab} setActiveTab={setActiveTab} label={TT.reports} />
      </div>
      {activeTab === "categories" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>
            {editingCategoryId ? TT.editCategory : TT.newCategory}
          </h2>

          <LanguageTabs
            langs={contentLangs}
            active={formLang}
            setActive={setFormLang}
            record={categoryForm}
            fields={["title"]}
          />

          <div style={styles.grid3}>
            <Input
              label={TEXT[formLang]?.titleField || TT.titleField}
              value={categoryForm[`title_${formLang}`]}
              onChange={(v) =>
                setCategoryForm({
                  ...categoryForm,
                  [`title_${formLang}`]: v,
                })
              }
            />
          </div>

          <div style={styles.row}>
            <label style={styles.checkLabel}>
              <input
                type="checkbox"
                checked={categoryForm.aktif}
                onChange={(e) =>
                  setCategoryForm({
                    ...categoryForm,
                    aktif: e.target.checked,
                  })
                }
              />
              {TT.active}
            </label>

            <button onClick={saveCategory} style={styles.primaryBtn}>
              {editingCategoryId ? TT.update : TT.save}
            </button>
          </div>

          <div style={styles.list}>
            {categories.map((cat) => (
              <div key={cat.id} style={styles.listItem}>
                <div>
                  <b>{getLocalized(cat, "title")}</b>
                  <LangBadges record={cat} fields={["title"]} />
                </div>

                <div style={styles.actions}>
                  <button
                    style={styles.editBtn}
                    onClick={() => {
                      setEditingCategoryId(cat.id);
                      setCategoryForm({
                        title_tr: cat.title_tr || "",
                        title_en: cat.title_en || "",
                        title_de: cat.title_de || "",
                        aktif: cat.aktif !== false,
                        sira: cat.sira || 0,
                      });
                    }}
                  >
                    {TT.edit}
                  </button>

                  <button
                    style={styles.deleteBtn}
                    onClick={() => deleteItem("categories", cat.id)}
                  >
                    {TT.delete}
                  </button>
                </div>
              </div>
            ))}
          </div>


        </section>
      )}

      {activeTab === "customerAccounts" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>💳 Müşteri Cari</h2>

          <div style={styles.noticeBox}>
            Müşterilerin paket, seans, ödeme ve kalan borç durumunu tek ekrandan takip edin.
          </div>

          <div style={styles.grid4}>
            <Input
              label="Müşteri Ara"
              value={customerAccountSearch}
              onChange={(v) => setCustomerAccountSearch(v)}
            />






         <label style={styles.label}>
  {TT.gender}
  <select
    style={styles.input}
    value={customerAccountGender}
    onChange={(e) => setCustomerAccountGender(e.target.value)}
  >
    <option value="all">Tümü</option>
    <option value="female">{TT.female}</option>
    <option value="male">{TT.male}</option>
  </select>
</label>

<label style={styles.label}>
  Durum
  <select
    style={styles.input}
    value={customerAccountStatus}
    onChange={(e) => setCustomerAccountStatus(e.target.value)}
  >
    <option value="all">Tümü</option>
    <option value="debt">Borcu Olanlar</option>
    <option value="remaining">Seansı Kalanlar</option>
    <option value="finished">Seansı Dolanlar</option>
  </select>
</label>

<Input
  label="Başlangıç Tarihi"
  type="date"
  value={customerAccountStartDate}
  onChange={(v) => setCustomerAccountStartDate(v)}
/>

<Input
  label="Bitiş Tarihi"
  type="date"
  value={customerAccountEndDate}
  onChange={(v) => setCustomerAccountEndDate(v)}
/>


          </div>

          <div style={styles.serviceGrid}>
            {customersPro
              .filter((c) => {
                const q = customerAccountSearch.trim().toLowerCase();
                const text = `${c.name || ""} ${c.phone || ""} ${c.note || ""}`.toLowerCase();

                if (q && !text.includes(q)) return false;
                if (customerAccountGender !== "all" && c.gender !== customerAccountGender) return false;

                return true;
              })
              .map((c) => {
                const customerPackages = packagesPro.filter(
                  (p) =>
                    String(p.customer_id) === String(c.id) ||
                    String(p.customer_name || "").toLowerCase() === String(c.name || "").toLowerCase()
                );

                const customerPayments = paymentsPro.filter(
                  (p) =>
                    String(p.customer_id) === String(c.id) ||
                    String(p.customer_name || "").toLowerCase() === String(c.name || "").toLowerCase()
                );

                const customerSessions = sessionsPro.filter(
                  (s) =>
                    String(s.customer_id) === String(c.id) ||
                    String(s.customer_name || "").toLowerCase() === String(c.name || "").toLowerCase()
                );

                const totalSale = customerPackages.reduce(
                  (sum, p) => sum + Number(p.amount || p.sale_price || 0),
                  0
                );

                const totalPaid = customerPayments.reduce(
                  (sum, p) => sum + Number(p.amount || 0),
                  0
                );

              const totalDebt = Math.max(totalSale - totalPaid, 0);

               const remainingSessions = customerPackages.reduce(
  (sum, p) => sum + Number(p.remaining_sessions || 0),
  0
);

if (customerAccountStatus === "debt" && totalDebt <= 0) return null;
if (customerAccountStatus === "remaining" && remainingSessions <= 0) return null;
if (customerAccountStatus === "finished" && remainingSessions > 0) return null;

                const phoneClean = String(c.phone || "").replace(/\D/g, "");
                const waText = encodeURIComponent(
                  `Merhaba ${c.name || ""}, güzellik merkezi randevu ve paket bilgileriniz hakkında sizinle iletişime geçmek istiyoruz.`
                );

                return (
                  <div key={c.id} style={styles.proMiniCard}>
                    <b>{c.name || "-"}</b>
                    <div style={styles.muted}>📞 {c.phone || "-"}</div><div style={styles.muted}>
  {TT.gender}: {
    c.gender === "male"
      ? TT.male
      : TT.female
  }
</div>

                    <hr style={styles.hr} />

                    <div style={styles.muted}>Paket Sayısı: {customerPackages.length}</div>
                    <div style={styles.muted}>Seans Sayısı: {customerSessions.length}</div>
                    <div style={styles.muted}>Kalan Seans: {remainingSessions}</div>
                    <div style={styles.muted}>Toplam Satış: {totalSale} TRY</div>
                    <div style={styles.muted}>Toplam Ödeme: {totalPaid} TRY</div>
                    <div style={styles.muted}>Kalan Borç: {totalDebt} TRY</div>

                    <hr style={styles.hr} />

                    <div style={styles.actions}>
                      {phoneClean && (
                        <a
                          href={`https://wa.me/${phoneClean}?text=${waText}`}
                          target="_blank"
                          rel="noreferrer"
                          style={styles.whatsappBtn}
                        >
                          WhatsApp
                        </a>
                      )}

                      <button style={styles.editBtn} onClick={() => printCustomerPro(c)}>
                        PDF / Yazdır
                      </button>
                    </div>
                  </div>
                );
              }).filter(Boolean)}
          </div>
        </section>
      )}

    {activeTab === "services" && (
  <section style={styles.card}>


    <h2 style={styles.cardTitle}>
      {editingServiceId ? TT.editService : TT.newService}
          </h2>

          <select
            style={styles.input}
            value={serviceForm.category_id}
            onChange={(e) =>
              setServiceForm({
                ...serviceForm,
                category_id: e.target.value,
              })
            }
          >
            <option value="">{TT.selectCategory}</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {getLocalized(cat, "title")}
              </option>
            ))}
          </select>

          <LanguageTabs
            langs={contentLangs}
            active={formLang}
            setActive={setFormLang}
            record={serviceForm}
            fields={["title", "description"]}
          />

          <div style={styles.grid3}>
            <Input
              label={TEXT[formLang]?.titleField || TT.titleField}
              value={serviceForm[`title_${formLang}`]}
              onChange={(v) =>
                setServiceForm({
                  ...serviceForm,
                  [`title_${formLang}`]: v,
                })
              }
            />
          </div>

          <div style={styles.grid3}>
            <Textarea
              label={TEXT[formLang]?.descField || TT.descField}
              value={serviceForm[`description_${formLang}`]}
              onChange={(v) =>
                setServiceForm({
                  ...serviceForm,
                  [`description_${formLang}`]: v,
                })
              }
            />
          </div>

          <div style={styles.grid4}>
         <Input
  label={TT.price}
  type="number"
  value={serviceForm[`price_${formLang}`]}
  onChange={(v) =>
    setServiceForm({
      ...serviceForm,
      [`price_${formLang}`]: v,
    })
  }
/>

<Select
  label={TT.currency}
  value={serviceForm[`currency_${formLang}`]}
  onChange={(v) =>
    setServiceForm({
      ...serviceForm,
      [`currency_${formLang}`]: v,
    })
  }
  options={["CHF", "EUR", "TRY", "USD"]}
/>
            <Input
              label={TT.duration}
              type="number"
              value={serviceForm.duration}
              onChange={(v) =>
                setServiceForm({
                  ...serviceForm,
                  duration: v,
                })
              }
            />
          </div>

          <div style={styles.imageUploadArea}>
            <label style={styles.label}>{TT.image}</label>

            <div style={styles.imageUploadWrapper}>
              {serviceImagePreview || (serviceForm.image && resolveImage(serviceForm.image)) ? (
                <img
                  src={serviceImagePreview || resolveImage(serviceForm.image)}
                  alt={TT.preview}
                  style={styles.imagePreview}
                />
              ) : (
                <div style={styles.imagePlaceholder}>🖼️</div>
              )}

              <ResimUpload
                label={TT.uploadImage}
                onUpload={(url) => {
                  setServiceForm({
                    ...serviceForm,
                    image: url,
                  });
                  setServiceImagePreview(url);
                }}
              />
            </div>
          </div>

          <div style={styles.row}>
            <label style={styles.checkLabel}>
              <input
                type="checkbox"
                checked={serviceForm.is_featured}
                onChange={(e) =>
                  setServiceForm({
                    ...serviceForm,
                    is_featured: e.target.checked,
                  })
                }
              />
              {TT.featured}
            </label>

            <label style={styles.checkLabel}>
              <input
                type="checkbox"
                checked={serviceForm.aktif}
                onChange={(e) =>
                  setServiceForm({
                    ...serviceForm,
                    aktif: e.target.checked,
                  })
                }
              />
              {TT.active}
            </label>

            <button onClick={saveService} style={styles.primaryBtn}>
              {editingServiceId ? TT.update : TT.save}
            </button>
          </div>

          <div style={styles.serviceGrid}>
            {services.map((srv) => (
              <div key={srv.id} style={styles.serviceCard}>
                <div style={styles.serviceImgBox}>
                  {srv.image ? (
                    <img src={resolveImage(srv.image)} alt="" style={styles.serviceImg} />
                  ) : (
                    <div style={styles.emptyImg}>✨</div>
                  )}
                </div>

                <div style={styles.serviceBody}>
                  <b>{getLocalized(srv, "title")}</b>
                  <LangBadges record={srv} fields={["title", "description"]} />

                  <div style={styles.muted}>
{srv[`price_${uiLang}`] || srv.price}{" "}
{srv[`currency_${uiLang}`] || srv.currency || "CHF"} · 
{srv.duration || "-"} dk
                  </div>

                  {srv.is_featured && <span style={styles.badge}>{TT.featuredBadge}</span>}

                  <div style={styles.actions}>
                    <button
                      style={styles.editBtn}
                      onClick={() => {
                        setEditingServiceId(srv.id);
                        setServiceForm({
                          category_id: srv.category_id || "",
                          title_tr: srv.title_tr || "",
                          title_en: srv.title_en || "",
                          title_de: srv.title_de || "",
                          description_tr: srv.description_tr || "",
                          description_en: srv.description_en || "",
                          description_de: srv.description_de || "",

                       price_tr: srv.price_tr || "",
price_en: srv.price_en || "",
price_de: srv.price_de || "",

currency_tr: srv.currency_tr || "TRY",
currency_en: srv.currency_en || "USD",
currency_de: srv.currency_de || "EUR",

duration: srv.duration || "",

                          image: srv.image || srv.image_url || "",
                          is_featured: srv.is_featured === true,
                          aktif: srv.aktif !== false,
                        });
                        setServiceImagePreview(srv.image || srv.image_url || "");
                      }}
                    >
                      {TT.edit}
                    </button>

                    <button
                      style={styles.deleteBtn}
                      onClick={() => deleteItem("services", srv.id)}
                    >
                      {TT.delete}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {activeTab === "faqs" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>
            {editingFaqId ? TT.editFaq : TT.newFaq}
          </h2>

          <LanguageTabs
            langs={contentLangs}
            active={formLang}
            setActive={setFormLang}
            record={faqForm}
            fields={["question", "answer"]}
          />

          <div style={styles.grid3}>
            <Input
              label={TEXT[formLang]?.questionField || TT.questionField}
              value={faqForm[`question_${formLang}`]}
              onChange={(v) =>
                setFaqForm({
                  ...faqForm,
                  [`question_${formLang}`]: v,
                })
              }
            />
          </div>

          <div style={styles.grid3}>
            <Textarea
              label={TEXT[formLang]?.answerField || TT.answerField}
              value={faqForm[`answer_${formLang}`]}
              onChange={(v) =>
                setFaqForm({
                  ...faqForm,
                  [`answer_${formLang}`]: v,
                })
              }
            />
          </div>

          <div style={styles.row}>
            <label style={styles.checkLabel}>
              <input
                type="checkbox"
                checked={faqForm.aktif}
                onChange={(e) =>
                  setFaqForm({
                    ...faqForm,
                    aktif: e.target.checked,
                  })
                }
              />
              {TT.active}
            </label>

            <button onClick={saveFaq} style={styles.primaryBtn}>
              {editingFaqId ? TT.update : TT.save}
            </button>
          </div>

          <div style={styles.list}>
            {faqs.map((faq) => (
              <div key={faq.id} style={styles.listItem}>
                <div>
                  <b>{getLocalized(faq, "question")}</b>
                  <LangBadges record={faq} fields={["question", "answer"]} />
                </div>

                <div style={styles.actions}>
                  <button
                    style={styles.editBtn}
                    onClick={() => {
                      setEditingFaqId(faq.id);
                      setFaqForm({
                        question_tr: faq.question_tr || "",
                        question_en: faq.question_en || "",
                        question_de: faq.question_de || "",
                        answer_tr: faq.answer_tr || "",
                        answer_en: faq.answer_en || "",
                        answer_de: faq.answer_de || "",
                        aktif: faq.aktif !== false,
                        sira: faq.sira || 0,
                      });
                    }}
                  >
                    {TT.edit}
                  </button>

                  <button
                    style={styles.deleteBtn}
                    onClick={() => deleteItem("faqs", faq.id)}
                  >
                    {TT.delete}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
{activeTab === "appointmentTypes" && (
  <section style={styles.card}>
    <h2 style={styles.cardTitle}>📅 Randevu Türleri / Çizelge Ayarları</h2>

    <div style={styles.noticeBox}>
      İşletme burada istediği kadar randevu türü ekleyebilir. Her randevu türü için ayrı başlangıç saati, bitiş saati ve dakika aralığı belirlenir.
    </div>

    <div style={styles.grid4}>
      <Input
        label="Randevu Türü"
        value={appointmentTypeForm.title}
        onChange={(v) =>
          setAppointmentTypeForm({
            ...appointmentTypeForm,
            title: v,
          })
        }
      />

      <Input
        label="Başlangıç Saati"
        type="time"
        value={appointmentTypeForm.start_time}
        onChange={(v) =>
          setAppointmentTypeForm({
            ...appointmentTypeForm,
            start_time: v,
          })
        }
      />

      <Input
        label="Bitiş Saati"
        type="time"
        value={appointmentTypeForm.end_time}
        onChange={(v) =>
          setAppointmentTypeForm({
            ...appointmentTypeForm,
            end_time: v,
          })
        }
      />

      <Input
        label="Saat Aralığı / Dakika"
        type="number"
        value={appointmentTypeForm.slot_minutes}
        onChange={(v) =>
          setAppointmentTypeForm({
            ...appointmentTypeForm,
            slot_minutes: v,
          })
        }
      />

      <Input
        label="Sıra"
        type="number"
        value={appointmentTypeForm.sira}
        onChange={(v) =>
          setAppointmentTypeForm({
            ...appointmentTypeForm,
            sira: v,
          })
        }
      />

      <label style={styles.checkLabel}>
        <input
          type="checkbox"
          checked={appointmentTypeForm.aktif === true}
          onChange={(e) =>
            setAppointmentTypeForm({
              ...appointmentTypeForm,
              aktif: e.target.checked,
            })
          }
        />
        Aktif
      </label>
    </div>

    <div style={styles.row}>
      <button style={styles.primaryBtn} onClick={saveAppointmentType}>
        {editingAppointmentTypeId ? "Randevu Türünü Güncelle" : "Randevu Türü Ekle"}
      </button>

      {editingAppointmentTypeId && (
        <button
          style={styles.editBtn}
          onClick={() => {
            setAppointmentTypeForm(emptyAppointmentType);
            setEditingAppointmentTypeId(null);
          }}
        >
          Vazgeç
        </button>
      )}
    </div>

    <div style={styles.list}>
      {appointmentTypes.length === 0 ? (
        <div style={styles.emptyBox}>Henüz randevu türü yok.</div>
      ) : (
        appointmentTypes.map((item) => (
          <div key={item.id} style={styles.listItem}>
            <div>
              <b>{item.title}</b>
              <div style={styles.muted}>
                Saat: {String(item.start_time || "").slice(0, 5)} - {String(item.end_time || "").slice(0, 5)}
              </div>
              <div style={styles.muted}>
                Aralık: {item.slot_minutes || 30} dk · {item.aktif === false ? "Pasif" : "Aktif"}
              </div>
            </div>

            <div style={styles.actions}>
              <button style={styles.editBtn} onClick={() => editAppointmentType(item)}>
                Düzenle
              </button>

              <button style={styles.deleteBtn} onClick={() => deleteAppointmentType(item.id)}>
                Sil
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  </section>
)}
      {activeTab === "appointments" && (
        <section style={styles.card}>
          <div style={styles.reportGrid}>
  <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("today")}>
    <span>Bugün</span>
    <b>{appointments.filter(a => dateOnly(a.appointment_date) === new Date().toISOString().slice(0, 10)).length}</b>
  </div>

  <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("all")}>
    <span>Toplam Randevu</span>
    <b>{appointments.length}</b>
  </div>

  <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("new")}>
    <span>Yeni Talepler</span>
    <b>{appointments.filter(a => a.status === "new").length}</b>
  </div>

  <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("completed")}>
    <span>Tamamlanan</span>
    <b>{appointments.filter(a => a.status === "completed").length}</b>
  </div>
</div>

          <div style={styles.list}>
            {appointments.length === 0 ? (
              <div style={styles.emptyBox}>{TT.noAppointment}</div>
            ) : (
              appointments
  .filter((a) => {
    if (appointmentReportFilter === "today") {
      return dateOnly(a.appointment_date) === new Date().toISOString().slice(0, 10);
    }
    if (appointmentReportFilter === "new") return a.status === "new";
    if (appointmentReportFilter === "completed") return a.status === "completed";
    return true;
  })
  .map((a) => (
                <div key={a.id} style={styles.appointmentItem}>
                  <div>
                    <b>{a.customer_name || a.name}</b>

                    <div style={styles.muted}>📞 {a.customer_phone || a.phone}</div>

                    <div style={styles.muted}>
                      📅 {a.appointment_date || "-"} / {a.appointment_time || "-"}
                    </div>

                    <div style={styles.muted}>📝 {a.note || "-"}</div>

                    <div style={styles.muted}>
                      {TT.status}: {a.status || "new"}
                    </div>
                  </div>

                  <div style={styles.actions}>
                    <button
                      style={styles.editBtn}
                      onClick={() => updateAppointmentStatus(a.id, "seen")}
                    >
                      {TT.seen}
                    </button>

                    <button
                      style={styles.primaryBtn}
                      onClick={() => updateAppointmentStatus(a.id, "completed")}
                    >
                      {TT.completed}
                    </button>

                    <button
                      style={styles.deleteBtn}
                      onClick={() => deleteItem("appointments", a.id)}
                    >
                      {TT.delete}
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      )}

{activeTab === "appointmentCreate" && (
  <section style={styles.card}>
    <h2 style={styles.cardTitle}>📅 Randevu Oluştur</h2>

    <div style={styles.reportGrid}>
      <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("today")}>
        <span>Bugün</span>
        <b>{appointments.filter(a => dateOnly(a.appointment_date) === new Date().toISOString().slice(0, 10)).length}</b>
      </div>

      <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("all")}>
        <span>Toplam Randevu</span>
        <b>{appointments.length}</b>
      </div>

      <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("new")}>
        <span>Yeni Talepler</span>
        <b>{appointments.filter(a => a.status === "new").length}</b>
      </div>

      <div style={styles.reportCard} onClick={() => setAppointmentReportFilter("completed")}>
        <span>Tamamlanan</span>
        <b>{appointments.filter(a => a.status === "completed").length}</b>
      </div>
    </div>

    <div style={styles.noticeBox}>
      Randevularınızı tek ekrandan planlayın, müşteri ve hizmet bilgilerini seçerek günlük çalışma akışınızı düzenli takip edin.
    </div>

    <div style={styles.grid4}>
      <label style={styles.label}>
        Müşteri
        <select
          style={styles.input}
          value={appointmentForm.customer_id}
          onChange={(e) => {
            const selected = customersPro.find((c) => String(c.id) === e.target.value);
            setAppointmentForm({
              ...appointmentForm,
              customer_id: e.target.value,
              customer_name: selected?.name || "",
              customer_phone: selected?.phone || "",
            });
          }}
        >
          <option value="">Müşteri seç</option>
          {customersPro.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name} {c.phone ? `- ${c.phone}` : ""}
            </option>
          ))}
        </select>
      </label>



<label style={styles.label}>
  Randevu Türü
  <select
    style={styles.input}
    value={appointmentForm.appointment_type_id}
    onChange={(e) => {
      const selected = appointmentTypes.find(
        (t) => String(t.id) === String(e.target.value)
      );

      setAppointmentForm({
        ...appointmentForm,
        appointment_type_id: e.target.value,
        appointment_type_title: selected?.title || "",
        appointment_time: "",
        duration: selected?.slot_minutes
          ? String(selected.slot_minutes)
          : appointmentForm.duration,
      });
    }}
  >
    <option value="">Randevu türü seç</option>

    {appointmentTypes
      .filter((t) => t.aktif !== false)
      .map((t) => (
        <option key={t.id} value={t.id}>
          {t.title} - {String(t.start_time || "").slice(0, 5)} /{" "}
          {String(t.end_time || "").slice(0, 5)} - {t.slot_minutes} dk
        </option>
      ))}
  </select>
</label>

<label style={styles.label}>
  Kategori
  <select
    style={styles.input}
    value={appointmentForm.category_id}
    onChange={(e) =>
      setAppointmentForm({
        ...appointmentForm,
        category_id: e.target.value,
        service_id: "",
        service_name: "",
      })
    }
  >
    <option value="">Kategori seç</option>
    {categories.map((cat) => (
      <option key={cat.id} value={cat.id}>
        {getLocalized(cat, "title")}
      </option>
    ))}
  </select>
</label>




      <label style={styles.label}>
        Hizmet
        <select
          style={styles.input}
          value={appointmentForm.service_id}
          onChange={(e) => {
            const selected = services.find((s) => String(s.id) === e.target.value);
            setAppointmentForm({
              ...appointmentForm,
              service_id: e.target.value,
              service_name: selected ? getLocalized(selected, "title") : "",
              duration: selected?.duration || appointmentForm.duration,
            });
          }}
        >
          <option value="">Hizmet seç</option>
          {services
            .filter((srv) =>
              appointmentForm.category_id
                ? String(srv.category_id) === String(appointmentForm.category_id)
                : true
            )
            .map((srv) => (
              <option key={srv.id} value={srv.id}>
                {getLocalized(srv, "title")}
              </option>
            ))}
        </select>
      </label>

    <label style={styles.label}>
  Personel
  <select
    style={styles.input}
    value={appointmentForm.staff_name}
    onChange={(e) =>
      setAppointmentForm({
        ...appointmentForm,
        staff_name: e.target.value,
      })
    }
  >
    <option value="">Personel seç</option>

    {staffPro.map((s) => (
      <option key={s.id} value={s.name}>
        {s.name}
      </option>
    ))}
  </select>
</label>

      <Input
        label="Randevu Tarihi"
        type="date"
        value={appointmentForm.appointment_date}
        onChange={(v) => setAppointmentForm({ ...appointmentForm, appointment_date: v })}
      />

    <label style={styles.label}>
  Randevu Saati
  <select
    style={styles.input}
    value={appointmentForm.appointment_time}
    disabled={!selectedAppointmentType}
    onChange={(e) =>
      setAppointmentForm({
        ...appointmentForm,
        appointment_time: e.target.value,
      })
    }
  >
    <option value="">
      {selectedAppointmentType ? "Saat seç" : "Önce randevu türü seç"}
    </option>

    {appointmentTimeOptions.map((time) => {
      const busy = getAppointmentConflict(time);

      return (
        <option key={time} value={time}>
          {time}
          {busy ? ` - DOLU (${busy.customer_name || "randevu var"})` : ""}
        </option>
      );
    })}
  </select>
</label>

{appointmentForm.appointment_time && getAppointmentConflict(appointmentForm.appointment_time) && (
  <div
    style={{
      ...styles.noticeBox,
      gridColumn: "1 / -1",
      background: "#fffbeb",
      borderColor: "#f59e0b",
      color: "#92400e",
    }}
  >
    ⚠️ Bu tarih ve saatte başka bir randevu var. Kaydetmeye basınca sistem tekrar uyarı verecek.
  </div>
)}

      <Input
        label="Süre / Dakika"
        type="number"
        value={appointmentForm.duration}
        onChange={(v) => setAppointmentForm({ ...appointmentForm, duration: v })}
      />

      <Input
        label="Not"
        value={appointmentForm.note}
        onChange={(v) => setAppointmentForm({ ...appointmentForm, note: v })}
      />
    </div>

    <div style={styles.row}>
     <button
  style={styles.primaryBtn}
  onClick={saveAppointmentManual}
>
  Randevu Kaydet
</button>
    </div>

    <h3 style={styles.cardTitle}>Randevu Listesi</h3>

    <div style={styles.list}>
      {appointments
        .filter((a) => {
          if (appointmentReportFilter === "today") {
            return dateOnly(a.appointment_date) === new Date().toISOString().slice(0, 10);
          }
          if (appointmentReportFilter === "new") return a.status === "new";
          if (appointmentReportFilter === "completed") return a.status === "completed";
          return true;
        })
        .map((a) => (
          <div key={a.id} style={styles.appointmentItem}>
            <div>
              <b>{a.customer_name || a.name}</b>
              <div style={styles.muted}>📞 {a.customer_phone || a.phone || "-"}</div>
              <div style={styles.muted}>📅 {formatDate(a.appointment_date)} / {String(a.appointment_time || "-").slice(0, 5)}</div>
              <div style={styles.muted}>📝 {a.note || "-"}</div>
              <div style={styles.muted}>Durum: {a.status || "new"}</div>
            </div>

            <div style={styles.actions}>
              <button style={styles.editBtn} onClick={() => updateAppointmentStatus(a.id, "seen")}>
                Görüldü
              </button>
              <button style={styles.primaryBtn} onClick={() => updateAppointmentStatus(a.id, "completed")}>
                Tamamlandı
              </button>
              <button style={styles.deleteBtn} onClick={() => deleteItem("appointments", a.id)}>
                Sil
              </button>
            </div>
          </div>
        ))}
    </div>
  </section>
)}


      {activeTab === "customers" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.customers}</h2>
          <div style={styles.noticeBox}>{TT.localNotice}</div>

          <div style={styles.grid4}>
          <Input 
label={TT.customerName} 
value={customerForm.full_name} 
onChange={(v) => 
setCustomerForm({ ...customerForm, full_name: v })} 
/>
            <Input label={TT.phone} value={customerForm.phone} onChange={(v) => setCustomerForm({ ...customerForm, phone: v })} />
  <Select
  label={TT.gender}
  value={customerForm.gender}
  onChange={(v) =>
    setCustomerForm({
      ...customerForm,
      gender: v,
    })
  }
  options={[
    { value: "female", label: TT.female },
    { value: "male", label: TT.male },
  ]}
/>
<Input
  label="E-Posta"
  value={customerForm.email}
  onChange={(v)=>setCustomerForm({...customerForm,email:v})}
/>

<Input
  label="Doğum Tarihi"
  type="date"
  value={customerForm.birth_date}
  onChange={(v)=>setCustomerForm({...customerForm,birth_date:v})}
/>

<Input
  label="Adres"
  value={customerForm.address}
  onChange={(v)=>setCustomerForm({...customerForm,address:v})}
/>

<Input
  label="Şehir"
  value={customerForm.city}
  onChange={(v)=>setCustomerForm({...customerForm,city:v})}
/>

            <Input label={TT.note} value={customerForm.note} onChange={(v) => setCustomerForm({ ...customerForm, note: v })} />
          </div>

          <div style={styles.row}>
        <button type="button" style={styles.primaryBtn} onClick={saveCustomerPro}>
  {TT.addCustomer}
</button>




          </div>

        <div style={styles.serviceGrid}>
  {customersPro.length === 0 ? (
    <div style={styles.emptyBox}>{TT.noRecord}</div>
  ) : (
    customersPro.map((c) => (
      <div key={c.id} style={styles.proMiniCard}>
        <b>{c.name}</b>
        <div style={styles.muted}>📞 {c.phone || "-"}</div>
        <div style={styles.muted}>Cinsiyet: {c.gender || "-"}</div>
        <div style={styles.muted}>Not: {c.note || "-"}</div>

        <div style={styles.actions}>
          <button style={styles.editBtn} onClick={() => printCustomerPro(c)}>
            PDF / Yazdır
          </button>

          <button
            style={styles.deleteBtn}
            onClick={() => deletePro(`/beaty/pro/customers/${c.id}`)}
          >
            {TT.delete}
          </button>
        </div>
      </div>
    ))
  )}
</div>


        </section>
      )}

      {activeTab === "devices" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.devices}</h2>
          <div style={styles.noticeBox}>{TT.localNotice}</div>

          <div style={styles.grid4}>
            <Input label={TT.deviceName} value={deviceForm.name} onChange={(v) => setDeviceForm({ ...deviceForm, name: v })} />
            <Input label={TT.areaName} value={deviceForm.area_name} onChange={(v) => setDeviceForm({ ...deviceForm, area_name: v })} />
            <Input label={TT.femalePrice} type="number" value={deviceForm.price_female} onChange={(v) => setDeviceForm({ ...deviceForm, price_female: v })} />
            <Input label={TT.malePrice} type="number" value={deviceForm.price_male} onChange={(v) => setDeviceForm({ ...deviceForm, price_male: v })} />
            <Select label={TT.currency} value={deviceForm.currency} onChange={(v) => setDeviceForm({ ...deviceForm, currency: v })} options={["CHF", "EUR", "TRY", "USD"]} />
          </div>

          <div style={styles.row}>
            <button style={styles.primaryBtn} onClick={saveDevicePro}>{TT.addDevice}</button>
          </div>

          <ProTable
            emptyText={TT.noRecord}
            rows={devicesPro}
            columns={[
              { key: "name", label: TT.deviceName },
              { key: "area", label: TT.areaName },
              { key: "price_female", label: TT.femalePrice },
              { key: "price_male", label: TT.malePrice },
              { key: "currency", label: TT.currency },
            ]}
            onDelete={(id) => String(id).startsWith("price-") ? deletePro(`/beaty/pro/device-prices/${String(id).replace("price-", "")}`) : deletePro(`/beaty/pro/devices/${id}`)}
            deleteLabel={TT.delete}
          />
        </section>
      )}

      {activeTab === "packages" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.packages}</h2>
          <div style={styles.noticeBox}>{TT.localNotice}</div>

          <div style={styles.grid4}>
           <label style={styles.label}>
  {TT.assignedCustomer}
  <select
    style={styles.input}
    value={packageForm.customer_id}
    onChange={(e) => {
      const selected = customersPro.find((c) => String(c.id) === e.target.value);
      setPackageForm({
        ...packageForm,
        customer_id: e.target.value,
        customer_name: selected?.name || "",
      });
    }}
  >
    <option value="">Müşteri seç</option>
    {customersPro.map((c) => (
      <option key={c.id} value={c.id}>
        {c.name} {c.phone ? `- ${c.phone}` : ""}
      </option>
    ))}
  </select>
</label>
      <Input label={TT.packageName} value={packageForm.package_title} onChange={(v) => setPackageForm({ ...packageForm, package_title: v })} />

            <Input label={TT.totalSessions} type="number" value={packageForm.total_sessions} onChange={(v) => setPackageForm({ ...packageForm, total_sessions: v })} />
           <Input label={TT.amount} type="number" value={packageForm.sale_price} onChange={(v) => setPackageForm({ ...packageForm, sale_price: v })} />
<Input label={TT.paid} type="number" value={packageForm.paid_amount} onChange={(v) => setPackageForm({ ...packageForm, paid_amount: v })} />

      <Input
  label="Satış Tarihi"
  type="date"
  value={packageForm.sale_date}
  onChange={(v) => setPackageForm({ ...packageForm, sale_date: v })}
/>

<Input
  label="Paket Başlangıç Tarihi"
  type="date"
  value={packageForm.package_start_date}
  onChange={(v) => setPackageForm({ ...packageForm, package_start_date: v })}
/>

<Input
  label="Paket Bitiş Tarihi"
  type="date"
  value={packageForm.package_end_date}
  onChange={(v) => setPackageForm({ ...packageForm, package_end_date: v })}
/>

<Input
  label="Sonraki Seans Tarihi"
  type="date"
  value={packageForm.next_session_date}
  onChange={(v) => setPackageForm({ ...packageForm, next_session_date: v })}
/>

<Input
  label="Paket Süresi / Ay"
  type="number"
  value={packageForm.package_period_months}
  onChange={(v) => setPackageForm({ ...packageForm, package_period_months: v })}
/>

<Input
  label="Paket Notu"
  value={packageForm.note}
  onChange={(v) => setPackageForm({ ...packageForm, note: v })}
/>
 </div>
          <div style={styles.row}>
            <button style={styles.primaryBtn} onClick={savePackagePro}>{TT.addPackage}</button>
          </div>

          <div style={styles.serviceGrid}>
            {packagesPro.length === 0 ? (
              <div style={styles.emptyBox}>{TT.noRecord}</div>
            ) : (
              packagesPro.map((pkg) => {
                const total = Number(pkg.total_sessions || 0);
                const used = Number(pkg.used_sessions || 0);
                const remaining = Math.max(total - used, 0);
                const debt = Math.max(Number(pkg.amount || 0) - Number(pkg.paid || 0), 0);
                const percent = total > 0 ? Math.min((used / total) * 100, 100) : 0;

                return (
                  <div key={pkg.id} style={styles.proMiniCard}>
                    <b>{pkg.customer_name}</b>
                    <div style={styles.muted}>{pkg.package_name}</div>
                    <div style={styles.progressOuter}><div style={{ ...styles.progressInner, width: `${percent}%` }} /></div>
                  <div style={styles.proInfoGrid}>
  <span>Satış Tarihi: <b>{formatDate(pkg.sale_date || pkg.created_at)}</b></span>
  <span>Vade Tarihi: <b>{formatDate(pkg.due_date)}</b></span>
  <span>Başlangıç: <b>{formatDate(pkg.package_start_date)}</b></span>
  <span>Bitiş: <b>{formatDate(pkg.package_end_date)}</b></span>
  <span>Sonraki Seans: <b>{formatDate(pkg.next_session_date)}</b></span>
  <span>Paket Süresi: <b>{pkg.package_period_months || "-"} Ay</b></span>

  <span>{TT.totalSessions}: <b>{total}</b></span>
  <span>{TT.usedSessions}: <b>{used}</b></span>
  <span>{TT.remainingSessions}: <b>{remaining}</b></span>
  <span>{TT.remainingDebt}: <b>{debt} {pkg.currency}</b></span>

  <span>Not: <b>{pkg.note || "-"}</b></span>
</div>
                 <button
  style={styles.deleteBtn}
  onClick={() => deletePro(`/beaty/pro/customer-packages/${pkg.id}`)}
>
  {TT.delete}
</button>
                  </div>
                );
              })
            )}
          </div>
        </section>
      )}

{activeTab === "sessions" && (
  <section style={styles.card}>
    <h2 style={styles.cardTitle}>🧾 Seans İşle</h2>
    <div style={styles.noticeBox}>
      Müşterinin paketinden seans düşümü yapın, tarih, saat ve personel bilgisiyle seans geçmişini takip edin.
    </div>

    <div style={styles.grid4}>
      <label style={styles.label}>
        Müşteri Paketi
        <select
          style={styles.input}
          value={sessionForm.customer_package_id}
          onChange={(e) => {
            const selected = packagesPro.find((p) => String(p.id) === e.target.value);
            setSessionForm({
              ...sessionForm,
              customer_package_id: e.target.value,
              customer_name: selected?.customer_name || "",
              package_name: selected?.package_name || selected?.package_title || "",
            });
          }}
        >
          <option value="">Paket seç</option>
          {packagesPro.map((p) => (
            <option key={p.id} value={p.id}>
              {p.customer_name} - {p.package_name || p.package_title} / Kalan: {p.remaining_sessions}
            </option>
          ))}
        </select>
      </label>

      <Input label="Seans Tarihi" type="date" value={sessionForm.session_date} onChange={(v) => setSessionForm({ ...sessionForm, session_date: v })} />
      <Input label="Seans Saati" type="time" value={sessionForm.session_time} onChange={(v) => setSessionForm({ ...sessionForm, session_time: v })} />

      <label style={styles.label}>
        Personel
        <select
          style={styles.input}
          value={sessionForm.staff_name}
          onChange={(e) => setSessionForm({ ...sessionForm, staff_name: e.target.value })}
        >
          <option value="">Personel seç</option>
          {staffPro.map((s) => (
            <option key={s.id} value={s.name}>{s.name}</option>
          ))}
        </select>
      </label>

      <Input label="Seans Notu" value={sessionForm.note} onChange={(v) => setSessionForm({ ...sessionForm, note: v })} />
    </div>

    <button onClick={completeSession} style={styles.primaryBtn}>
      {TT.addSession}
    </button>

    <ProTable
      columns={[
        { key: "customer_name", label: TT.customerName },
        { key: "package_name", label: TT.packageName },
        { 
  key: "session_date_text", 
  label: "Seans Tarihi" 
},
        { key: "session_time", label: "Saat" },
        { key: "staff_name", label: TT.staffName },
        { key: "note", label: TT.note },
      ]}
      rows={sessionsPro}
      onDelete={(id) => deletePro(`/beaty/pro/sessions/${id}`)}
      deleteLabel={TT.delete}
      emptyText={TT.noRecord}
    />
  </section>
)}

      {activeTab === "staff" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.staff}</h2>
          <div style={styles.noticeBox}>{TT.localNotice}</div>

          <div style={styles.grid3}>
            <Input label={TT.staffName} value={staffForm.name} onChange={(v) => setStaffForm({ ...staffForm, name: v })} />
            <Input label={TT.expertise} value={staffForm.expertise} onChange={(v) => setStaffForm({ ...staffForm, expertise: v })} />
            <Input label={TT.phone} value={staffForm.phone} onChange={(v) => setStaffForm({ ...staffForm, phone: v })} />
          </div>

          <div style={styles.row}>
            <button style={styles.primaryBtn} onClick={saveStaffPro}>{TT.addStaff}</button>
          </div>

          <ProTable
            emptyText={TT.noRecord}
            rows={staffPro}
            columns={[
              { key: "name", label: TT.staffName },
              { key: "expertise", label: TT.expertise },
              { key: "phone", label: TT.phone },
            ]}
            onDelete={() => alert("Personel silme backend route’u eklenmedi. Gerekirse backend’e DELETE /staff/:id ekleriz.")}
            deleteLabel={TT.delete}
          />
        </section>
      )}

      {activeTab === "payments" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.payments}</h2>
          <div style={styles.noticeBox}>{TT.localNotice}</div>

          <div style={styles.grid4}>
       <label style={styles.label}>
  {TT.assignedCustomer}

  <select
    style={styles.input}
    value={paymentForm.customer_id}
    onChange={(e) => {
      const c = customersPro.find(
        (x) => String(x.id) === String(e.target.value)
      );

      setPaymentForm({
        ...paymentForm,
        customer_id: c?.id || "",
        customer_name: c?.name || c?.full_name || "",
      });
    }}
  >
    <option value="">Müşteri seç</option>

    {customersPro.map((c) => (
      <option key={c.id} value={c.id}>
        {c.name || c.full_name} - {c.phone || ""}
      </option>
    ))}
  </select>
</label>
            <Input label={TT.amount} type="number" value={paymentForm.amount} onChange={(v) => setPaymentForm({ ...paymentForm, amount: v })} />
            <Select label={TT.currency} value={paymentForm.currency} onChange={(v) => setPaymentForm({ ...paymentForm, currency: v })} options={["CHF", "EUR", "TRY", "USD"]} />
         <Input
  label={TT.note}
  value={paymentForm.note}
  onChange={(v) => setPaymentForm({ ...paymentForm, note: v })}
/>

<Input
  label="Tarih"
  type="date"
  value={paymentForm.payment_date}
  onChange={(v) =>
    setPaymentForm({
      ...paymentForm,
      payment_date: v,
    })
  }
/>
          </div>

          <div style={styles.row}>
            <button style={styles.primaryBtn} onClick={savePaymentPro}>{TT.addPayment}</button>
          </div>

          <ProTable
            emptyText={TT.noRecord}
            rows={paymentsPro}
            columns={[
              { key: "created_at", label: "Tarih" },
              { key: "customer_name", label: TT.assignedCustomer },
              { key: "amount", label: TT.amount },
              { key: "currency", label: TT.currency },
              { key: "note", label: TT.note },
            ]}
       onDelete={(id) => deletePro(`/beaty/pro/payments/${id}`)}
            deleteLabel={TT.delete}
          />
        </section>
      )}






{activeTab === "reports" && (
  <section style={styles.reportPage}>
    <div style={styles.reportHeader}>
      <div style={{ width: "100%" }}>
        <h2 style={styles.reportTitle}>📊 Kurumsal Rapor Paneli</h2>
        <p style={styles.reportSubtitle}>
          Satış, tahsilat, seans, müşteri ve randevu performansını tek ekrandan takip edin.
        </p>

        <div style={styles.grid4}>
          <Input
            label="Başlangıç Tarihi"
            type="date"
            value={reportStartDate}
            onChange={(v) => setReportStartDate(v)}
          />

          <Input
            label="Bitiş Tarihi"
            type="date"
            value={reportEndDate}
            onChange={(v) => setReportEndDate(v)}
          />

          <button
            style={styles.editBtn}
            onClick={() => {
              const today = new Date().toISOString().slice(0, 10);
              setReportStartDate(today);
              setReportEndDate(today);
            }}
          >
            Bugün
          </button>

          <button
            style={styles.editBtn}
            onClick={() => {
              setReportStartDate("");
              setReportEndDate("");
            }}
          >
            Tüm Zamanlar
          </button>
        </div>
      </div>
    </div>

    <div style={styles.dailySchedulePanel}>
      <div style={styles.dailyScheduleHeader}>
        <div>
          <h3 style={styles.dailyScheduleTitle}>📅 Günlük Randevu Çizelgesi</h3>
          <p style={styles.dailyScheduleSubtitle}>
            Randevu türleri, saat aralıkları, müşteri, personel ve hizmet bilgileri panel kayıtlarından otomatik hazırlanır.
          </p>
        </div>

        <div style={styles.dailyScheduleActions}>
          <Input
            label="Çizelge Tarihi"
            type="date"
            value={dailyScheduleDate}
            onChange={(v) => setDailyScheduleDate(v)}
          />

          <button style={styles.editBtn} onClick={loadAll}>
            Yenile
          </button>

          <button style={styles.primaryBtn} onClick={printDailyAppointmentSchedule}>
            Çıktı Al
          </button>
        </div>
      </div>

      <div style={styles.scheduleSummaryGrid}>
        <div style={styles.scheduleSummaryCard}>
          <span>Günlük Randevu</span>
          <b>{reportData.dailyAppointments.length}</b>
        </div>

        <div style={styles.scheduleSummaryCard}>
          <span>Yeni Talep</span>
          <b>{reportData.dailyAppointments.filter((a) => a.status === "new").length}</b>
        </div>

        <div style={styles.scheduleSummaryCard}>
          <span>Tamamlanan</span>
          <b>{reportData.dailyAppointments.filter((a) => a.status === "completed").length}</b>
        </div>

        <div style={styles.scheduleSummaryCard}>
          <span>Randevu Türü</span>
          <b>{reportData.dailyScheduleGroups.length}</b>
        </div>
      </div>

      {reportData.dailyScheduleGroups.length === 0 ? (
        <div style={styles.emptyBox}>
          Önce “Randevu Türleri” bölümünden çizelge türü eklemelisin.
        </div>
      ) : (
        reportData.dailyScheduleGroups.map((group) => (
          <div key={group.id} style={styles.dailyScheduleGroup}>
            <div style={styles.dailyScheduleGroupTitle}>
              <span>{group.title}</span>
              <small>
                {group.start_time} - {group.end_time} / {group.slot_minutes} dk
              </small>
            </div>

            <div style={styles.scheduleTableWrap}>
              <table style={styles.scheduleTable}>
                <thead>
                  <tr>
                    <th style={styles.scheduleTh}>Saat</th>
                    <th style={styles.scheduleTh}>Ad Soyad</th>
                    <th style={styles.scheduleTh}>Telefon</th>
                    <th style={styles.scheduleTh}>Estetisyen</th>
                    <th style={styles.scheduleTh}>Açıklama</th>
                    <th style={styles.scheduleTh}>Paket / Ücret</th>
                  </tr>
                </thead>

                <tbody>
                  {group.rows.map((row, index) => {
                    const a = row.appointment;

                    return (
                      <tr
                        key={`${group.id}-${row.time}-${index}`}
                        style={a ? styles.scheduleFilledRow : styles.scheduleEmptyRow}
                      >
                        <td style={{ ...styles.scheduleTd, ...styles.scheduleTimeTd }}>
                          {row.time}
                        </td>

                        <td style={styles.scheduleTd}>
                          {a?.customer_name || a?.name || ""}
                        </td>

                        <td style={styles.scheduleTd}>
                          {a?.customer_phone || a?.phone || ""}
                        </td>

                        <td style={styles.scheduleTd}>
                          {a ? getAppointmentStaffName(a) : ""}
                        </td>

                        <td style={styles.scheduleTd}>
                          {a ? (
                            <>
                              <b>{getAppointmentServiceName(a)}</b>
                              {getAppointmentDurationText(a) && (
                                <div style={styles.muted}>
                                  {getAppointmentDurationText(a)}
                                </div>
                              )}
                              {a.note && (
                                <div style={styles.muted}>
                                  {a.note}
                                </div>
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </td>

                        <td style={styles.scheduleTd}>
                          {a ? getAppointmentPackageFee(a) : ""}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}

      {reportData.untypedDailyAppointments.length > 0 && (
        <div style={styles.untypedScheduleBox}>
          <b>Türü Belirsiz Randevular</b>
          <p>
            Eski kayıtlar veya randevu türü bilgisi olmayan kayıtlar burada görünür.
          </p>

          {reportData.untypedDailyAppointments.map((a) => (
            <div key={a.id} style={styles.reportListItem}>
              <b>
                {String(a.appointment_time || "").slice(0, 5)} -{" "}
                {a.customer_name || a.name || "-"}
              </b>
              <div style={styles.muted}>
                {a.customer_phone || a.phone || "-"} / {getAppointmentStaffName(a)}
              </div>
              <div style={styles.muted}>
                {getAppointmentServiceName(a)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    <div style={styles.reportGrid}>
      <ReportKpi title="Toplam Satış" value={`${reportData.totalSales.toLocaleString()} TRY`} note="Paket satış toplamı" />
      <ReportKpi title="Tahsil Edilen" value={`${reportData.totalPayments.toLocaleString()} TRY`} note="Alınan ödemeler" />
      <ReportKpi title="Kalan Alacak" value={`${reportData.totalDebt.toLocaleString()} TRY`} note="Bekleyen cari bakiye" danger />
      <ReportKpi title="Aktif Müşteri" value={customersPro.length} note="Kayıtlı müşteri sayısı" />
    </div>

    <div style={styles.reportProgressGrid}>
      <ProgressCard
        title="Tahsilat Başarı Oranı"
        value={reportData.collectionRate}
        text={`${reportData.totalPayments.toLocaleString()} TRY tahsil edildi`}
      />

      <ProgressCard
        title="Seans Kullanım Oranı"
        value={reportData.sessionRate}
        text={`${reportData.usedSessions} / ${reportData.totalSessions} seans kullanıldı`}
      />

      <ProgressCard
        title="Borç Risk Oranı"
        value={reportData.debtRate}
        text={`${reportData.totalDebt.toLocaleString()} TRY bekleyen alacak`}
        danger
      />

      <ProgressCard
        title="Randevu Tamamlama"
        value={reportData.appointmentRate}
        text={`${reportData.filteredAppointments.filter((a) => a.status === "completed").length} randevu tamamlandı`}
      />
    </div>

    <div style={styles.reportTwoCol}>
      <div style={styles.reportPanel}>
        <h3 style={styles.reportPanelTitle}>📦 Paket & Seans Durumu</h3>

        <div style={styles.reportLine}>
          <span>Satılan Paket</span>
          <b>{packagesPro.length}</b>
        </div>

        <div style={styles.reportLine}>
          <span>Toplam Seans</span>
          <b>{reportData.totalSessions}</b>
        </div>

        <div style={styles.reportLine}>
          <span>Kullanılan Seans</span>
          <b>{reportData.usedSessions}</b>
        </div>

        <div style={styles.reportLine}>
          <span>Kalan Seans</span>
          <b>{reportData.remainingSessions}</b>
        </div>
      </div>

      <div style={styles.reportPanel}>
        <h3 style={styles.reportPanelTitle}>⚠️ İşletme Uyarıları</h3>

        <div style={styles.alertLine}>
          Borcu olan müşteri/paket sayısı:{" "}
          <b>{packagesPro.filter((p) => Number(p.debt_amount || 0) > 0).length}</b>
        </div>

        <div style={styles.alertLine}>
          Seansı kalan paket sayısı:{" "}
          <b>{packagesPro.filter((p) => Number(p.remaining_sessions || 0) > 0).length}</b>
        </div>

        <div style={styles.alertLine}>
          Seansı biten paket sayısı:{" "}
          <b>{packagesPro.filter((p) => Number(p.remaining_sessions || 0) <= 0).length}</b>
        </div>

        <div style={styles.alertLine}>
          Yeni randevu talebi:{" "}
          <b>{appointments.filter((a) => a.status === "new").length}</b>
        </div>
      </div>
    </div>

    <hr style={styles.hr} />

    <div style={styles.reportSectionTitle}>
      📌 Önümüzdeki 30 Gün
    </div>

    <div style={styles.grid2}>
      <div style={styles.reportListCard}>
        <h3 style={styles.cardTitle}>📅 Yaklaşan Randevular</h3>

        {reportData.upcomingAppointments.length === 0 ? (
          <div style={styles.emptyBox}>Önümüzdeki 30 gün içinde randevu yok.</div>
        ) : (
          reportData.upcomingAppointments.map((a) => (
            <div key={a.id} style={styles.reportListItem}>
              <b>{a.customer_name || a.name || "-"}</b>
              <div style={styles.muted}>📞 {a.customer_phone || a.phone || "-"}</div>
              <div style={styles.muted}>
                Randevu: {dateOnly(a.appointment_date)} / Saat: {a.appointment_time || "-"}
              </div>
            </div>
          ))
        )}
      </div>

      <div style={styles.reportListCard}>
        <h3 style={styles.cardTitle}>🎂 Yaklaşan Doğum Günleri</h3>

        {reportData.upcomingBirthdays.length === 0 ? (
          <div style={styles.emptyBox}>Önümüzdeki 30 gün içinde doğum günü yok.</div>
        ) : (
          reportData.upcomingBirthdays.map((c) => (
            <div key={c.id} style={styles.reportListItem}>
              <b>{c.name || c.full_name || "-"}</b>
              <div style={styles.muted}>📞 {c.phone || "-"}</div>
              <div style={styles.muted}>Doğum Tarihi: {dateOnly(c.birth_date)}</div>
            </div>
          ))
        )}
      </div>
    </div>
  </section>
)}




    </div>
  );
}

function ReportKpi({ title, value, note, danger }) {
  return (
    <div style={danger ? styles.reportKpiDanger : styles.reportKpi}>
      <span style={styles.reportKpiTitle}>{title}</span>
      <b style={styles.reportKpiValue}>{value}</b>
      <small style={styles.reportKpiNote}>{note}</small>
    </div>
  );
}

function ProgressCard({ title, value, text, danger }) {
  const safeValue = Math.max(0, Math.min(Number(value || 0), 100));

  return (
    <div style={styles.progressCard}>
      <div style={styles.progressTop}>
        <span>{title}</span>
        <b>{safeValue}%</b>
      </div>

      <div style={styles.progressTrack}>
        <div
          style={{
            ...styles.progressFill,
            width: `${safeValue}%`,
            background: danger
              ? "linear-gradient(90deg, #ef4444, #f97316)"
              : "linear-gradient(90deg, #2563eb, #06b6d4)",
          }}
        />
      </div>

      <small style={styles.progressText}>{text}</small>
    </div>
  );
}


function ProTable({ rows, columns, onDelete, deleteLabel, emptyText }) {
  if (!rows || rows.length === 0) {
    return <div style={styles.emptyBox}>{emptyText}</div>;
  }

  return (
    <div style={styles.proTableWrap}>
      <table style={styles.proTable}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} style={styles.proTh}>{c.label}</th>
            ))}
            <th style={styles.proTh}></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((c) => (
                <td key={c.key} style={styles.proTd}>{row[c.key] || "-"}</td>
              ))}
              <td style={styles.proTd}>
                <button style={styles.deleteBtn} onClick={() => onDelete(row.id)}>{deleteLabel}</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function LangBadges({ record, fields }) {
  return (
    <div style={styles.langBadges}>
      {CONTENT_LANGS.map((l) => {
        const ok = fields.every((field) => {
          const value = record?.[`${field}_${l.code}`];
          return value && String(value).trim() !== "";
        });

        return (
          <span
            key={l.code}
            style={{
              ...styles.langBadge,
              ...(ok ? styles.langBadgeOk : styles.langBadgeEmpty),
            }}
          >
            {l.label} {ok ? "✓" : "!"}
          </span>
        );
      })}
    </div>
  );
}

function LanguageTabs({ langs, active, setActive, record, fields }) {
  return (
    <div style={styles.formLangTabs}>
      {langs.map((l) => {
        const ok = fields.every((field) => {
          const value = record?.[`${field}_${l.code}`];
          return value && String(value).trim() !== "";
        });

        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setActive(l.code)}
            style={{
              ...styles.formLangBtn,
              ...(active === l.code ? styles.formLangBtnActive : {}),
            }}
          >
            {l.label} {ok ? "✓" : "!"}
          </button>
        );
      })}
    </div>
  );
}

function Stat({ title, value }) {
  return (
    <div style={styles.statCard}>
      <div style={styles.statValue}>{value}</div>
      <div style={styles.statTitle}>{title}</div>
    </div>
  );
}

function Tab({ id, activeTab, setActiveTab, label }) {
  return (
    <button
      onClick={() => setActiveTab(id)}
      style={{
        ...styles.tab,
        ...(activeTab === id ? styles.tabActive : {}),
      }}
    >
      {label}
    </button>
  );
}

function Input({ label, value, onChange, type = "text" }) {
  return (
    <label style={styles.label}>
      {label}
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={styles.input}
      />
    </label>
  );
}

function Textarea({ label, value, onChange }) {
  return (
    <label style={styles.label}>
      {label}
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={{ ...styles.input, minHeight: 90 }}
      />
    </label>
  );
}

function Select({ label, value, onChange, options }) {
  return (
    <label style={styles.label}>
      {label}
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={styles.input}
      >
       {options.map((o) => (
  <option 
    key={typeof o === "object" ? o.value : o}
    value={typeof o === "object" ? o.value : o}
  >
    {typeof o === "object" ? o.label : o}
  </option>
))}
      </select>
    </label>
  );
}

const styles = {
  page: {
    padding: 24,
    background: "#f8fafc",
    minHeight: "100vh",
    color: "#111827",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  },
  loading: {
    padding: 50,
    fontWeight: 800,
    textAlign: "center",
  },
  header: {
    background: "linear-gradient(135deg,#7c2d12,#be185d,#6d28d9)",
    color: "#fff",
    borderRadius: 28,
    padding: 28,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 20,
    flexWrap: "wrap",
    boxShadow: "0 18px 45px rgba(109,40,217,.25)",
  },
  title: {
    margin: 0,
    fontSize: 30,
    fontWeight: 900,
  },
  subtitle: {
    margin: "8px 0 0",
    opacity: 0.9,
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
    gap: 16,
    margin: "22px 0",
  },
  statCard: {
    background: "#fff",
    borderRadius: 22,
    padding: 20,
    boxShadow: "0 12px 30px rgba(15,23,42,.08)",
    border: "1px solid #e5e7eb",
  },
  statValue: {
    fontSize: 32,
    fontWeight: 900,
    color: "#be185d",
  },
  statTitle: {
    color: "#6b7280",
    fontWeight: 700,
  },
  tabs: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 18,
  },
  tab: {
    border: "1px solid #e5e7eb",
    background: "#fff",
    padding: "11px 18px",
    borderRadius: 999,
    fontWeight: 900,
    cursor: "pointer",
  },
  tabActive: {
    background: "linear-gradient(135deg,#be185d,#6d28d9)",
    color: "#fff",
    borderColor: "transparent",
  },
  card: {
    background: "#fff",
    borderRadius: 26,
    padding: 22,
    boxShadow: "0 14px 34px rgba(15,23,42,.08)",
    border: "1px solid #e5e7eb",
  },
  cardTitle: {
    marginTop: 0,
    fontSize: 24,
    fontWeight: 900,
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(230px,1fr))",
    gap: 14,
    marginBottom: 14,
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(190px,1fr))",
    gap: 14,
    marginBottom: 14,
  },
  label: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    fontWeight: 800,
    color: "#374151",
  },
  input: {
    padding: "12px 14px",
    borderRadius: 14,
    border: "1px solid #d1d5db",
    fontSize: 15,
    boxSizing: "border-box",
    width: "100%",
    fontFamily: "inherit",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    margin: "16px 0",
  },
  checkLabel: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 800,
  },
  primaryBtn: {
    border: "none",
    background: "linear-gradient(135deg,#be185d,#6d28d9)",
    color: "#fff",
    borderRadius: 999,
    padding: "10px 16px",
    fontWeight: 900,
    cursor: "pointer",
  },
  editBtn: {
    border: "none",
    background: "#fef3c7",
    color: "#92400e",
    borderRadius: 999,
    padding: "8px 13px",
    fontWeight: 900,
    cursor: "pointer",
  },
  deleteBtn: {
    border: "none",
    background: "#fee2e2",
    color: "#991b1b",
    borderRadius: 999,
    padding: "8px 13px",
    fontWeight: 900,
    cursor: "pointer",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
  },
  listItem: {
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 18,
    padding: 14,
    display: "flex",
    justifyContent: "space-between",
    gap: 14,
    flexWrap: "wrap",
  },
  actions: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    alignItems: "center",
  },
  muted: {
    color: "#6b7280",
    fontSize: 13,
    marginTop: 3,
  },
  serviceGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
    gap: 16,
    marginTop: 18,
  },
  serviceCard: {
    border: "1px solid #e5e7eb",
    borderRadius: 22,
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0 10px 24px rgba(15,23,42,.06)",
  },
  serviceImgBox: {
    height: 160,
    background: "#fce7f3",
  },
  serviceImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  emptyImg: {
    height: "100%",
    display: "grid",
    placeItems: "center",
    fontSize: 42,
  },
  serviceBody: {
    padding: 14,
  },
  badge: {
    display: "inline-block",
    background: "#fce7f3",
    color: "#be185d",
    borderRadius: 999,
    padding: "4px 9px",
    fontSize: 12,
    fontWeight: 900,
    marginTop: 8,
  },
  appointmentItem: {
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 18,
    padding: 14,
    display: "flex",
    justifyContent: "space-between",
    gap: 14,
    flexWrap: "wrap",
  },
  emptyBox: {
    padding: 28,
    textAlign: "center",
    color: "#9ca3af",
    fontWeight: 800,
  },
  imageUploadArea: {
    marginBottom: 14,
  },
  imageUploadWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
  },
  imagePreview: {
    width: 100,
    height: 100,
    objectFit: "cover",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
  },
  imagePlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 12,
    border: "1px dashed #cbd5e1",
    display: "grid",
    placeItems: "center",
    fontSize: 32,
    color: "#94a3b8",
    background: "#f8fafc",
  },
  formLangTabs: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 16,
  },
  formLangBtn: {
    border: "1px solid #e5e7eb",
    background: "#fff",
    borderRadius: 999,
    padding: "8px 14px",
    fontWeight: 900,
    cursor: "pointer",
  },
  formLangBtnActive: {
    background: "linear-gradient(135deg,#be185d,#6d28d9)",
    color: "#fff",
    borderColor: "transparent",
  },
  langBadges: {
    display: "flex",
    gap: 6,
    flexWrap: "wrap",
    marginTop: 8,
  },
  langBadge: {
    borderRadius: 999,
    padding: "3px 8px",
    fontSize: 12,
    fontWeight: 900,
  },
  langBadgeOk: {
    background: "#dcfce7",
    color: "#166534",
  },
  langBadgeEmpty: {
    background: "#fee2e2",
    color: "#991b1b",
  },

  proBanner: {
    background: "linear-gradient(135deg,#fff7ed,#eff6ff)",
    border: "1px solid #fed7aa",
    borderRadius: 24,
    padding: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 14,
    flexWrap: "wrap",
    marginBottom: 18,
    boxShadow: "0 10px 25px rgba(30,64,175,.08)",
  },
  proBannerTitle: {
    margin: 0,
    fontSize: 22,
    fontWeight: 900,
    color: "#1e40af",
  },
  proBannerText: {
    margin: "6px 0 0",
    color: "#475569",
    fontWeight: 700,
  },
  proBadge: {
    background: "linear-gradient(135deg,#f97316,#2563eb)",
    color: "#fff",
    borderRadius: 999,
    padding: "9px 16px",
    fontWeight: 900,
    letterSpacing: 1,
  },
  noticeBox: {
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    color: "#1e40af",
    borderRadius: 16,
    padding: 12,
    fontWeight: 800,
    marginBottom: 16,
  },
  proTableWrap: {
    overflowX: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: 18,
    marginTop: 16,
  },
  proTable: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 720,
    background: "#fff",
  },
  proTh: {
    textAlign: "left",
    padding: 12,
    background: "#f8fafc",
    color: "#334155",
    fontSize: 13,
    fontWeight: 900,
    borderBottom: "1px solid #e5e7eb",
  },
  proTd: {
    padding: 12,
    borderBottom: "1px solid #f1f5f9",
    color: "#334155",
    fontWeight: 700,
    verticalAlign: "middle",
  },
  proMiniCard: {
    border: "1px solid #e5e7eb",
    borderRadius: 20,
    padding: 16,
    background: "linear-gradient(180deg,#ffffff,#f8fafc)",
    boxShadow: "0 10px 24px rgba(15,23,42,.06)",
  },
  progressOuter: {
    height: 10,
    background: "#e5e7eb",
    borderRadius: 999,
    overflow: "hidden",
    margin: "12px 0",
  },
  progressInner: {
    height: "100%",
    background: "linear-gradient(135deg,#f97316,#2563eb)",
    borderRadius: 999,
  },
  proInfoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
    gap: 8,
    color: "#475569",
    fontSize: 13,
    marginBottom: 12,
  },

reportCard: {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: 18,
  boxShadow: "0 12px 28px rgba(15,23,42,.08)",
  cursor: "pointer",
},

reportPage: {
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
  borderRadius: 24,
  padding: 24,
  boxShadow: "0 20px 50px rgba(15, 23, 42, 0.08)",
  border: "1px solid #e5e7eb",
},
reportHeader: {
  display: "flex",
  justifyContent: "space-between",
  gap: 16,
  alignItems: "center",
  marginBottom: 22,
  flexWrap: "wrap",
},
reportTitle: {
  margin: 0,
  fontSize: 26,
  fontWeight: 900,
  color: "#0f172a",
},
reportSubtitle: {
  margin: "8px 0 0",
  color: "#64748b",
  fontSize: 14,
},
reportDateBox: {
  background: "#0f172a",
  color: "#fff",
  padding: "14px 18px",
  borderRadius: 18,
  display: "flex",
  flexDirection: "column",
  gap: 4,
  minWidth: 170,
},
reportKpi: {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 20,
  padding: 20,
  boxShadow: "0 10px 25px rgba(15, 23, 42, 0.06)",
},
reportKpiDanger: {
  background: "linear-gradient(135deg, #fff7ed, #ffffff)",
  border: "1px solid #fed7aa",
  borderRadius: 20,
  padding: 20,
  boxShadow: "0 10px 25px rgba(249, 115, 22, 0.10)",
},
reportKpiTitle: {
  color: "#64748b",
  fontSize: 13,
  fontWeight: 700,
},
reportKpiValue: {
  display: "block",
  marginTop: 8,
  fontSize: 25,
  color: "#0f172a",
},
reportKpiNote: {
  display: "block",
  marginTop: 8,
  color: "#94a3b8",
},
reportProgressGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 16,
  marginTop: 18,
},
progressCard: {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 20,
  padding: 18,
  boxShadow: "0 10px 25px rgba(15, 23, 42, 0.06)",
},
progressTop: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: 800,
  color: "#0f172a",
  marginBottom: 12,
},
progressTrack: {
  width: "100%",
  height: 12,
  background: "#e5e7eb",
  borderRadius: 999,
  overflow: "hidden",
},
progressFill: {
  height: "100%",
  borderRadius: 999,
  transition: "width 900ms ease",
},
progressText: {
  display: "block",
  marginTop: 10,
  color: "#64748b",
},
reportTwoCol: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: 18,
  marginTop: 18,
},
reportPanel: {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 22,
  padding: 20,
  boxShadow: "0 10px 25px rgba(15, 23, 42, 0.06)",
},
reportPanelTitle: {
  margin: "0 0 16px",
  color: "#0f172a",
  fontSize: 18,
},
grid2: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
  gap: 16,
  marginTop: 20,
},
reportLine: {
  display: "flex",
  justifyContent: "space-between",
  padding: "12px 0",
  borderBottom: "1px solid #f1f5f9",
  color: "#334155",
},
alertLine: {
  background: "#f8fafc",
  border: "1px solid #e5e7eb",
  padding: 12,
  borderRadius: 14,
  marginBottom: 10,
  color: "#334155",
},


  reportGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
    gap: 14,
  },
  reportCard: {
    background: "linear-gradient(135deg,#fff7ed,#eff6ff)",
    border: "1px solid #e5e7eb",
    borderRadius: 20,
    padding: 18,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    color: "#334155",
    fontWeight: 800,
  },
  dailySchedulePanel: {
    background: "linear-gradient(135deg,#ffffff,#f8fafc)",
    border: "1px solid #e5e7eb",
    borderRadius: 24,
    padding: 20,
    marginBottom: 22,
    boxShadow: "0 14px 35px rgba(15,23,42,.08)",
  },
  dailyScheduleHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 16,
    flexWrap: "wrap",
    marginBottom: 18,
  },
  dailyScheduleTitle: {
    margin: 0,
    fontSize: 22,
    fontWeight: 900,
    color: "#0f172a",
  },
  dailyScheduleSubtitle: {
    margin: "6px 0 0",
    color: "#64748b",
    fontWeight: 700,
    maxWidth: 780,
  },
  dailyScheduleActions: {
    display: "flex",
    gap: 10,
    alignItems: "end",
    flexWrap: "wrap",
  },
  scheduleSummaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
    gap: 12,
    marginBottom: 18,
  },
  scheduleSummaryCard: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 18,
    padding: 14,
    boxShadow: "0 8px 20px rgba(15,23,42,.06)",
  },
  dailyScheduleGroup: {
    marginTop: 18,
    border: "1px solid #111827",
    borderRadius: 18,
    overflow: "hidden",
    background: "#fff",
  },
  dailyScheduleGroupTitle: {
    background: "#111827",
    color: "#fff",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    gap: 10,
    alignItems: "center",
    flexWrap: "wrap",
    fontWeight: 900,
    fontSize: 17,
  },
  scheduleTableWrap: {
    overflowX: "auto",
  },
  scheduleTable: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 920,
    tableLayout: "fixed",
  },
  scheduleTh: {
    border: "1px solid #111827",
    background: "#f3f4f6",
    padding: 10,
    fontSize: 13,
    fontWeight: 900,
    color: "#111827",
    textAlign: "center",
  },
  scheduleTd: {
    border: "1px solid #111827",
    padding: 10,
    fontSize: 13,
    color: "#111827",
    verticalAlign: "top",
    minHeight: 42,
    wordBreak: "break-word",
  },
  scheduleTimeTd: {
    width: 80,
    textAlign: "center",
    fontWeight: 900,
    fontSize: 15,
    background: "#f9fafb",
  },
  scheduleFilledRow: {
    background: "#fff7ed",
  },
  scheduleEmptyRow: {
    background: "#ffffff",
  },
  untypedScheduleBox: {
    marginTop: 18,
    background: "#fffbeb",
    border: "1px solid #f59e0b",
    borderRadius: 18,
    padding: 16,
    color: "#92400e",
  },
};